
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b70"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b70"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hWds8", function(module, exports) {

$parcel$export(module.exports, "PathTracingRenderer", () => $d0f249dd9f03ac59$export$196da6cc71a4331);

var $ilwiq = parcelRequire("ilwiq");

var $RPVlj = parcelRequire("RPVlj");

var $4dqlL = parcelRequire("4dqlL");

var $9kitj = parcelRequire("9kitj");

var $ieQ3q = parcelRequire("ieQ3q");
function* $d0f249dd9f03ac59$var$renderTask() {
    const { _renderer: _renderer, _fsQuad: _fsQuad, _blendQuad: _blendQuad, _primaryTarget: _primaryTarget, _blendTargets: _blendTargets, _sobolTarget: _sobolTarget, _subframe: _subframe, alpha: alpha, material: material } = this;
    const _ogScissor = new (0, $ilwiq.Vector4)();
    const _ogViewport = new (0, $ilwiq.Vector4)();
    const blendMaterial = _blendQuad.material;
    let [blendTarget1, blendTarget2] = _blendTargets;
    while(true){
        if (alpha) {
            blendMaterial.opacity = this._opacityFactor / (this.samples + 1);
            material.blending = (0, $ilwiq.NoBlending);
            material.opacity = 1;
        } else {
            material.opacity = this._opacityFactor / (this.samples + 1);
            material.blending = (0, $ilwiq.NormalBlending);
        }
        const [subX, subY, subW, subH] = _subframe;
        const w = _primaryTarget.width;
        const h = _primaryTarget.height;
        material.resolution.set(w * subW, h * subH);
        material.sobolTexture = _sobolTarget.texture;
        material.stratifiedTexture.init(20, material.bounces + material.transmissiveBounces + 5);
        material.stratifiedTexture.next();
        material.seed++;
        const tilesX = this.tiles.x || 1;
        const tilesY = this.tiles.y || 1;
        const totalTiles = tilesX * tilesY;
        const pxSubW = Math.ceil(w * subW);
        const pxSubH = Math.ceil(h * subH);
        const pxSubX = Math.floor(subX * w);
        const pxSubY = Math.floor(subY * h);
        const pxTileW = Math.ceil(pxSubW / tilesX);
        const pxTileH = Math.ceil(pxSubH / tilesY);
        for(let y = 0; y < tilesY; y++)for(let x = 0; x < tilesX; x++){
            // store og state
            const ogRenderTarget = _renderer.getRenderTarget();
            const ogAutoClear = _renderer.autoClear;
            const ogScissorTest = _renderer.getScissorTest();
            _renderer.getScissor(_ogScissor);
            _renderer.getViewport(_ogViewport);
            let tx = x;
            let ty = y;
            if (!this.stableTiles) {
                const tileIndex = this._currentTile % (tilesX * tilesY);
                tx = tileIndex % tilesX;
                ty = ~~(tileIndex / tilesX);
                this._currentTile = tileIndex + 1;
            }
            // set the scissor and the viewport on the render target
            // note that when using the webgl renderer set viewport the device pixel ratio
            // is multiplied into the field causing some pixels to not be rendered
            const reverseTy = tilesY - ty - 1;
            _primaryTarget.scissor.set(pxSubX + tx * pxTileW, pxSubY + reverseTy * pxTileH, Math.min(pxTileW, pxSubW - tx * pxTileW), Math.min(pxTileH, pxSubH - reverseTy * pxTileH));
            _primaryTarget.viewport.set(pxSubX, pxSubY, pxSubW, pxSubH);
            // three.js renderer takes values relative to the current pixel ratio
            _renderer.setRenderTarget(_primaryTarget);
            _renderer.setScissorTest(true);
            _renderer.autoClear = false;
            _fsQuad.render(_renderer);
            // reset original renderer state
            _renderer.setViewport(_ogViewport);
            _renderer.setScissor(_ogScissor);
            _renderer.setScissorTest(ogScissorTest);
            _renderer.setRenderTarget(ogRenderTarget);
            _renderer.autoClear = ogAutoClear;
            // swap and blend alpha targets
            if (alpha) {
                blendMaterial.target1 = blendTarget1.texture;
                blendMaterial.target2 = _primaryTarget.texture;
                _renderer.setRenderTarget(blendTarget2);
                _blendQuad.render(_renderer);
                _renderer.setRenderTarget(ogRenderTarget);
            }
            this.samples += 1 / totalTiles;
            // round the samples value if we've finished the tiles
            if (x === tilesX - 1 && y === tilesY - 1) this.samples = Math.round(this.samples);
            yield;
        }
        [blendTarget1, blendTarget2] = [
            blendTarget2,
            blendTarget1
        ];
    }
}
const $d0f249dd9f03ac59$var$ogClearColor = new (0, $ilwiq.Color)();
class $d0f249dd9f03ac59$export$196da6cc71a4331 {
    get material() {
        return this._fsQuad.material;
    }
    set material(v) {
        this._fsQuad.material.removeEventListener("recompilation", this._compileFunction);
        v.addEventListener("recompilation", this._compileFunction);
        this._fsQuad.material = v;
    }
    get target() {
        return this._alpha ? this._blendTargets[1] : this._primaryTarget;
    }
    set alpha(v) {
        if (this._alpha === v) return;
        if (!v) {
            this._blendTargets[0].dispose();
            this._blendTargets[1].dispose();
        }
        this._alpha = v;
        this.reset();
    }
    get alpha() {
        return this._alpha;
    }
    get isCompiling() {
        return Boolean(this._compilePromise);
    }
    constructor(renderer){
        this.camera = null;
        this.tiles = new (0, $ilwiq.Vector2)(3, 3);
        this.stableNoise = false;
        this.stableTiles = true;
        this.samples = 0;
        this._subframe = new (0, $ilwiq.Vector4)(0, 0, 1, 1);
        this._opacityFactor = 1.0;
        this._renderer = renderer;
        this._alpha = false;
        this._fsQuad = new (0, $RPVlj.FullScreenQuad)(new (0, $ieQ3q.PhysicalPathTracingMaterial)());
        this._blendQuad = new (0, $RPVlj.FullScreenQuad)(new (0, $4dqlL.BlendMaterial)());
        this._task = null;
        this._currentTile = 0;
        this._compilePromise = null;
        this._sobolTarget = new (0, $9kitj.SobolNumberMapGenerator)().generate(renderer);
        this._primaryTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            format: (0, $ilwiq.RGBAFormat),
            type: (0, $ilwiq.FloatType),
            magFilter: (0, $ilwiq.NearestFilter),
            minFilter: (0, $ilwiq.NearestFilter)
        });
        this._blendTargets = [
            new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
                format: (0, $ilwiq.RGBAFormat),
                type: (0, $ilwiq.FloatType),
                magFilter: (0, $ilwiq.NearestFilter),
                minFilter: (0, $ilwiq.NearestFilter)
            }),
            new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
                format: (0, $ilwiq.RGBAFormat),
                type: (0, $ilwiq.FloatType),
                magFilter: (0, $ilwiq.NearestFilter),
                minFilter: (0, $ilwiq.NearestFilter)
            })
        ];
        // function for listening to for triggered compilation so we can wait for compilation to finish
        // before starting to render
        this._compileFunction = ()=>{
            const promise = this.compileMaterial(this._fsQuad._mesh);
            promise.then(()=>{
                if (this._compilePromise === promise) this._compilePromise = null;
            });
            this._compilePromise = promise;
        };
        this.material.addEventListener("recompilation", this._compileFunction);
    }
    compileMaterial() {
        return this._renderer.compileAsync(this._fsQuad._mesh);
    }
    setCamera(camera) {
        const { material: material } = this;
        material.cameraWorldMatrix.copy(camera.matrixWorld);
        material.invProjectionMatrix.copy(camera.projectionMatrixInverse);
        material.physicalCamera.updateFrom(camera);
        // Perspective camera (default)
        let cameraType = 0;
        // An orthographic projection matrix will always have the bottom right element == 1
        // And a perspective projection matrix will always have the bottom right element == 0
        if (camera.projectionMatrix.elements[15] > 0) // Orthographic
        cameraType = 1;
        if (camera.isEquirectCamera) // Equirectangular
        cameraType = 2;
        material.setDefine("CAMERA_TYPE", cameraType);
        this.camera = camera;
    }
    setSize(w, h) {
        w = Math.ceil(w);
        h = Math.ceil(h);
        if (this._primaryTarget.width === w && this._primaryTarget.height === h) return;
        this._primaryTarget.setSize(w, h);
        this._blendTargets[0].setSize(w, h);
        this._blendTargets[1].setSize(w, h);
        this.reset();
    }
    getSize(target) {
        target.x = this._primaryTarget.width;
        target.y = this._primaryTarget.height;
    }
    dispose() {
        this._primaryTarget.dispose();
        this._blendTargets[0].dispose();
        this._blendTargets[1].dispose();
        this._sobolTarget.dispose();
        this._fsQuad.dispose();
        this._blendQuad.dispose();
        this._task = null;
    }
    reset() {
        const { _renderer: _renderer, _primaryTarget: _primaryTarget, _blendTargets: _blendTargets } = this;
        const ogRenderTarget = _renderer.getRenderTarget();
        const ogClearAlpha = _renderer.getClearAlpha();
        _renderer.getClearColor($d0f249dd9f03ac59$var$ogClearColor);
        _renderer.setRenderTarget(_primaryTarget);
        _renderer.setClearColor(0, 0);
        _renderer.clearColor();
        _renderer.setRenderTarget(_blendTargets[0]);
        _renderer.setClearColor(0, 0);
        _renderer.clearColor();
        _renderer.setRenderTarget(_blendTargets[1]);
        _renderer.setClearColor(0, 0);
        _renderer.clearColor();
        _renderer.setClearColor($d0f249dd9f03ac59$var$ogClearColor, ogClearAlpha);
        _renderer.setRenderTarget(ogRenderTarget);
        this.samples = 0;
        this._task = null;
        this.material.stratifiedTexture.stableNoise = this.stableNoise;
        if (this.stableNoise) {
            this.material.seed = 0;
            this.material.stratifiedTexture.reset();
        }
    }
    update() {
        // ensure we've updated our defines before rendering so we can ensure we
        // can wait for compilation to finish
        this.material.onBeforeRender();
        if (this.isCompiling) return;
        if (!this._task) this._task = $d0f249dd9f03ac59$var$renderTask.call(this);
        this._task.next();
    }
}

});
parcelRegister("4dqlL", function(module, exports) {

$parcel$export(module.exports, "BlendMaterial", () => $311cd0e92e040f64$export$70ee8b3cbd6f21d8);

var $ilwiq = parcelRequire("ilwiq");

var $9fZ6X = parcelRequire("9fZ6X");
class $311cd0e92e040f64$export$70ee8b3cbd6f21d8 extends (0, $9fZ6X.MaterialBase) {
    constructor(parameters){
        super({
            blending: (0, $ilwiq.NoBlending),
            uniforms: {
                target1: {
                    value: null
                },
                target2: {
                    value: null
                },
                opacity: {
                    value: 1.0
                }
            },
            vertexShader: /* glsl */ `

				varying vec2 vUv;

				void main() {

					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

				}`,
            fragmentShader: /* glsl */ `

				uniform float opacity;

				uniform sampler2D target1;
				uniform sampler2D target2;

				varying vec2 vUv;

				void main() {

					vec4 color1 = texture2D( target1, vUv );
					vec4 color2 = texture2D( target2, vUv );

					float invOpacity = 1.0 - opacity;
					float totalAlpha = color1.a * invOpacity + color2.a * opacity;

					if ( color1.a != 0.0 || color2.a != 0.0 ) {

						gl_FragColor.rgb = color1.rgb * ( invOpacity * color1.a / totalAlpha ) + color2.rgb * ( opacity * color2.a / totalAlpha );
						gl_FragColor.a = totalAlpha;

					} else {

						gl_FragColor = vec4( 0.0 );

					}

				}`
        });
        this.setValues(parameters);
    }
}

});

parcelRegister("9kitj", function(module, exports) {

$parcel$export(module.exports, "SobolNumberMapGenerator", () => $6ca44f672d576995$export$4e8e5459f15b1dca);

var $ilwiq = parcelRequire("ilwiq");

var $RPVlj = parcelRequire("RPVlj");

var $9fZ6X = parcelRequire("9fZ6X");

var $ffLvN = parcelRequire("ffLvN");
class $6ca44f672d576995$var$SobolNumbersMaterial extends (0, $9fZ6X.MaterialBase) {
    constructor(){
        super({
            blending: (0, $ilwiq.NoBlending),
            uniforms: {
                resolution: {
                    value: new (0, $ilwiq.Vector2)()
                }
            },
            vertexShader: /* glsl */ `

				varying vec2 vUv;
				void main() {

					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

				}
			`,
            fragmentShader: /* glsl */ `

				${(0, $ffLvN.sobol_common)}
				${(0, $ffLvN.sobol_point_generation)}

				varying vec2 vUv;
				uniform vec2 resolution;
				void main() {

					uint index = uint( gl_FragCoord.y ) * uint( resolution.x ) + uint( gl_FragCoord.x );
					gl_FragColor = generateSobolPoint( index );

				}
			`
        });
    }
}
class $6ca44f672d576995$export$4e8e5459f15b1dca {
    generate(renderer, dimensions = 256) {
        const target = new (0, $ilwiq.WebGLRenderTarget)(dimensions, dimensions, {
            type: (0, $ilwiq.FloatType),
            format: (0, $ilwiq.RGBAFormat),
            minFilter: (0, $ilwiq.NearestFilter),
            magFilter: (0, $ilwiq.NearestFilter),
            generateMipmaps: false
        });
        const ogTarget = renderer.getRenderTarget();
        renderer.setRenderTarget(target);
        const quad = new (0, $RPVlj.FullScreenQuad)(new $6ca44f672d576995$var$SobolNumbersMaterial());
        quad.material.resolution.set(dimensions, dimensions);
        quad.render(renderer);
        renderer.setRenderTarget(ogTarget);
        quad.dispose();
        return target;
    }
}

});
parcelRegister("ffLvN", function(module, exports) {

$parcel$export(module.exports, "sobol_common", () => $b1ad1c9578ecec04$export$603c58c7e29c9b0);
$parcel$export(module.exports, "sobol_point_generation", () => $b1ad1c9578ecec04$export$96e4d35266bd337b);
$parcel$export(module.exports, "sobol_functions", () => $b1ad1c9578ecec04$export$79b4ab6803c188d5);
// References
// - https://jcgt.org/published/0009/04/01/
// - Code from https://www.shadertoy.com/view/WtGyDm
// functions to generate multi-dimensions variables of the same functions
// to support 1, 2, 3, and 4 dimensional sobol sampling.
function $b1ad1c9578ecec04$var$generateSobolFunctionVariants(dim = 1) {
    let type = "uint";
    if (dim > 1) type = "uvec" + dim;
    return /* glsl */ `
		${type} sobolReverseBits( ${type} x ) {

			x = ( ( ( x & 0xaaaaaaaau ) >> 1 ) | ( ( x & 0x55555555u ) << 1 ) );
			x = ( ( ( x & 0xccccccccu ) >> 2 ) | ( ( x & 0x33333333u ) << 2 ) );
			x = ( ( ( x & 0xf0f0f0f0u ) >> 4 ) | ( ( x & 0x0f0f0f0fu ) << 4 ) );
			x = ( ( ( x & 0xff00ff00u ) >> 8 ) | ( ( x & 0x00ff00ffu ) << 8 ) );
			return ( ( x >> 16 ) | ( x << 16 ) );

		}

		${type} sobolHashCombine( uint seed, ${type} v ) {

			return seed ^ ( v + ${type}( ( seed << 6 ) + ( seed >> 2 ) ) );

		}

		${type} sobolLaineKarrasPermutation( ${type} x, ${type} seed ) {

			x += seed;
			x ^= x * 0x6c50b47cu;
			x ^= x * 0xb82f1e52u;
			x ^= x * 0xc7afe638u;
			x ^= x * 0x8d22f6e6u;
			return x;

		}

		${type} nestedUniformScrambleBase2( ${type} x, ${type} seed ) {

			x = sobolLaineKarrasPermutation( x, seed );
			x = sobolReverseBits( x );
			return x;

		}
	`;
}
function $b1ad1c9578ecec04$var$generateSobolSampleFunctions(dim = 1) {
    let utype = "uint";
    let vtype = "float";
    let num = "";
    let components = ".r";
    let combineValues = "1u";
    if (dim > 1) {
        utype = "uvec" + dim;
        vtype = "vec" + dim;
        num = dim + "";
        if (dim === 2) {
            components = ".rg";
            combineValues = "uvec2( 1u, 2u )";
        } else if (dim === 3) {
            components = ".rgb";
            combineValues = "uvec3( 1u, 2u, 3u )";
        } else {
            components = "";
            combineValues = "uvec4( 1u, 2u, 3u, 4u )";
        }
    }
    return /* glsl */ `

		${vtype} sobol${num}( int effect ) {

			uint seed = sobolGetSeed( sobolBounceIndex, uint( effect ) );
			uint index = sobolPathIndex;

			uint shuffle_seed = sobolHashCombine( seed, 0u );
			uint shuffled_index = nestedUniformScrambleBase2( sobolReverseBits( index ), shuffle_seed );
			${vtype} sobol_pt = sobolGetTexturePoint( shuffled_index )${components};
			${utype} result = ${utype}( sobol_pt * 16777216.0 );

			${utype} seed2 = sobolHashCombine( seed, ${combineValues} );
			result = nestedUniformScrambleBase2( result, seed2 );

			return SOBOL_FACTOR * ${vtype}( result >> 8 );

		}
	`;
}
const $b1ad1c9578ecec04$export$603c58c7e29c9b0 = /* glsl */ `

	// Utils
	const float SOBOL_FACTOR = 1.0 / 16777216.0;
	const uint SOBOL_MAX_POINTS = 256u * 256u;

	${$b1ad1c9578ecec04$var$generateSobolFunctionVariants(1)}
	${$b1ad1c9578ecec04$var$generateSobolFunctionVariants(2)}
	${$b1ad1c9578ecec04$var$generateSobolFunctionVariants(3)}
	${$b1ad1c9578ecec04$var$generateSobolFunctionVariants(4)}

	uint sobolHash( uint x ) {

		// finalizer from murmurhash3
		x ^= x >> 16;
		x *= 0x85ebca6bu;
		x ^= x >> 13;
		x *= 0xc2b2ae35u;
		x ^= x >> 16;
		return x;

	}

`;
const $b1ad1c9578ecec04$export$96e4d35266bd337b = /* glsl */ `

	const uint SOBOL_DIRECTIONS_1[ 32 ] = uint[ 32 ](
		0x80000000u, 0xc0000000u, 0xa0000000u, 0xf0000000u,
		0x88000000u, 0xcc000000u, 0xaa000000u, 0xff000000u,
		0x80800000u, 0xc0c00000u, 0xa0a00000u, 0xf0f00000u,
		0x88880000u, 0xcccc0000u, 0xaaaa0000u, 0xffff0000u,
		0x80008000u, 0xc000c000u, 0xa000a000u, 0xf000f000u,
		0x88008800u, 0xcc00cc00u, 0xaa00aa00u, 0xff00ff00u,
		0x80808080u, 0xc0c0c0c0u, 0xa0a0a0a0u, 0xf0f0f0f0u,
		0x88888888u, 0xccccccccu, 0xaaaaaaaau, 0xffffffffu
	);

	const uint SOBOL_DIRECTIONS_2[ 32 ] = uint[ 32 ](
		0x80000000u, 0xc0000000u, 0x60000000u, 0x90000000u,
		0xe8000000u, 0x5c000000u, 0x8e000000u, 0xc5000000u,
		0x68800000u, 0x9cc00000u, 0xee600000u, 0x55900000u,
		0x80680000u, 0xc09c0000u, 0x60ee0000u, 0x90550000u,
		0xe8808000u, 0x5cc0c000u, 0x8e606000u, 0xc5909000u,
		0x6868e800u, 0x9c9c5c00u, 0xeeee8e00u, 0x5555c500u,
		0x8000e880u, 0xc0005cc0u, 0x60008e60u, 0x9000c590u,
		0xe8006868u, 0x5c009c9cu, 0x8e00eeeeu, 0xc5005555u
	);

	const uint SOBOL_DIRECTIONS_3[ 32 ] = uint[ 32 ](
		0x80000000u, 0xc0000000u, 0x20000000u, 0x50000000u,
		0xf8000000u, 0x74000000u, 0xa2000000u, 0x93000000u,
		0xd8800000u, 0x25400000u, 0x59e00000u, 0xe6d00000u,
		0x78080000u, 0xb40c0000u, 0x82020000u, 0xc3050000u,
		0x208f8000u, 0x51474000u, 0xfbea2000u, 0x75d93000u,
		0xa0858800u, 0x914e5400u, 0xdbe79e00u, 0x25db6d00u,
		0x58800080u, 0xe54000c0u, 0x79e00020u, 0xb6d00050u,
		0x800800f8u, 0xc00c0074u, 0x200200a2u, 0x50050093u
	);

	const uint SOBOL_DIRECTIONS_4[ 32 ] = uint[ 32 ](
		0x80000000u, 0x40000000u, 0x20000000u, 0xb0000000u,
		0xf8000000u, 0xdc000000u, 0x7a000000u, 0x9d000000u,
		0x5a800000u, 0x2fc00000u, 0xa1600000u, 0xf0b00000u,
		0xda880000u, 0x6fc40000u, 0x81620000u, 0x40bb0000u,
		0x22878000u, 0xb3c9c000u, 0xfb65a000u, 0xddb2d000u,
		0x78022800u, 0x9c0b3c00u, 0x5a0fb600u, 0x2d0ddb00u,
		0xa2878080u, 0xf3c9c040u, 0xdb65a020u, 0x6db2d0b0u,
		0x800228f8u, 0x400b3cdcu, 0x200fb67au, 0xb00ddb9du
	);

	uint getMaskedSobol( uint index, uint directions[ 32 ] ) {

		uint X = 0u;
		for ( int bit = 0; bit < 32; bit ++ ) {

			uint mask = ( index >> bit ) & 1u;
			X ^= mask * directions[ bit ];

		}
		return X;

	}

	vec4 generateSobolPoint( uint index ) {

		if ( index >= SOBOL_MAX_POINTS ) {

			return vec4( 0.0 );

		}

		// NOTE: this sobol "direction" is also available but we can't write out 5 components
		// uint x = index & 0x00ffffffu;
		uint x = sobolReverseBits( getMaskedSobol( index, SOBOL_DIRECTIONS_1 ) ) & 0x00ffffffu;
		uint y = sobolReverseBits( getMaskedSobol( index, SOBOL_DIRECTIONS_2 ) ) & 0x00ffffffu;
		uint z = sobolReverseBits( getMaskedSobol( index, SOBOL_DIRECTIONS_3 ) ) & 0x00ffffffu;
		uint w = sobolReverseBits( getMaskedSobol( index, SOBOL_DIRECTIONS_4 ) ) & 0x00ffffffu;

		return vec4( x, y, z, w ) * SOBOL_FACTOR;

	}

`;
const $b1ad1c9578ecec04$export$79b4ab6803c188d5 = /* glsl */ `

	// Seeds
	uniform sampler2D sobolTexture;
	uint sobolPixelIndex = 0u;
	uint sobolPathIndex = 0u;
	uint sobolBounceIndex = 0u;

	uint sobolGetSeed( uint bounce, uint effect ) {

		return sobolHash(
			sobolHashCombine(
				sobolHashCombine(
					sobolHash( bounce ),
					sobolPixelIndex
				),
				effect
			)
		);

	}

	vec4 sobolGetTexturePoint( uint index ) {

		if ( index >= SOBOL_MAX_POINTS ) {

			index = index % SOBOL_MAX_POINTS;

		}

		uvec2 dim = uvec2( textureSize( sobolTexture, 0 ).xy );
		uint y = index / dim.x;
		uint x = index - y * dim.x;
		vec2 uv = vec2( x, y ) / vec2( dim );
		return texture( sobolTexture, uv );

	}

	${$b1ad1c9578ecec04$var$generateSobolSampleFunctions(1)}
	${$b1ad1c9578ecec04$var$generateSobolSampleFunctions(2)}
	${$b1ad1c9578ecec04$var$generateSobolSampleFunctions(3)}
	${$b1ad1c9578ecec04$var$generateSobolSampleFunctions(4)}

`;

});


parcelRegister("ieQ3q", function(module, exports) {

$parcel$export(module.exports, "PhysicalPathTracingMaterial", () => $d471e9adcf389a5c$export$746cbc9e65f5bcb8);

var $ilwiq = parcelRequire("ilwiq");

var $9fZ6X = parcelRequire("9fZ6X");

var $2vjHu = parcelRequire("2vjHu");
var $3mzmA = parcelRequire("3mzmA");
var $hN8zD = parcelRequire("hN8zD");

var $iyhQ7 = parcelRequire("iyhQ7");

var $kAJM1 = parcelRequire("kAJM1");

var $TWVPU = parcelRequire("TWVPU");

var $6Q19u = parcelRequire("6Q19u");

var $laA5G = parcelRequire("laA5G");

var $12pjC = parcelRequire("12pjC");

var $k5Ikv = parcelRequire("k5Ikv");

var $hLXJE = parcelRequire("hLXJE");

var $sORjD = parcelRequire("sORjD");
var $WBvYF = parcelRequire("WBvYF");
var $1QwjS = parcelRequire("1QwjS");
var $1r4sY = parcelRequire("1r4sY");
var $asLEI = parcelRequire("asLEI");

var $6VF8W = parcelRequire("6VF8W");
var $232IN = parcelRequire("232IN");
var $cp6U0 = parcelRequire("cp6U0");

var $8KxWl = parcelRequire("8KxWl");
var $fYvb1 = parcelRequire("fYvb1");
var $d9skn = parcelRequire("d9skn");
var $jpfro = parcelRequire("jpfro");
var $dUUQZ = parcelRequire("dUUQZ");

var $kmALz = parcelRequire("kmALz");
var $ffLvN = parcelRequire("ffLvN");
var $gCBx4 = parcelRequire("gCBx4");

var $6voD8 = parcelRequire("6voD8");
var $4GDCw = parcelRequire("4GDCw");
var $8keuf = parcelRequire("8keuf");
var $9kAYu = parcelRequire("9kAYu");
var $5SszG = parcelRequire("5SszG");

var $hB5SN = parcelRequire("hB5SN");

var $1zk7M = parcelRequire("1zk7M");
var $eJ3gD = parcelRequire("eJ3gD");
var $eZnIg = parcelRequire("eZnIg");
var $bwtQK = parcelRequire("bwtQK");
var $ioRiK = parcelRequire("ioRiK");
var $euI5d = parcelRequire("euI5d");
class $d471e9adcf389a5c$export$746cbc9e65f5bcb8 extends (0, $9fZ6X.MaterialBase) {
    onBeforeRender() {
        this.setDefine("FEATURE_DOF", this.physicalCamera.bokehSize === 0 ? 0 : 1);
        this.setDefine("FEATURE_BACKGROUND_MAP", this.backgroundMap ? 1 : 0);
        this.setDefine("FEATURE_FOG", this.materials.features.isUsed("FOG") ? 1 : 0);
    }
    constructor(parameters){
        super({
            transparent: true,
            depthWrite: false,
            defines: {
                FEATURE_MIS: 1,
                FEATURE_RUSSIAN_ROULETTE: 1,
                FEATURE_DOF: 1,
                FEATURE_BACKGROUND_MAP: 0,
                FEATURE_FOG: 1,
                // 0 = PCG
                // 1 = Sobol
                // 2 = Stratified List
                RANDOM_TYPE: 2,
                // 0 = Perspective
                // 1 = Orthographic
                // 2 = Equirectangular
                CAMERA_TYPE: 0,
                DEBUG_MODE: 0,
                ATTR_NORMAL: 0,
                ATTR_TANGENT: 1,
                ATTR_UV: 2,
                ATTR_COLOR: 3,
                MATERIAL_PIXELS: (0, $laA5G.MATERIAL_PIXELS)
            },
            uniforms: {
                // path trace uniforms
                resolution: {
                    value: new (0, $ilwiq.Vector2)()
                },
                opacity: {
                    value: 1
                },
                bounces: {
                    value: 10
                },
                transmissiveBounces: {
                    value: 10
                },
                filterGlossyFactor: {
                    value: 0
                },
                // camera uniforms
                physicalCamera: {
                    value: new (0, $iyhQ7.PhysicalCameraUniform)()
                },
                cameraWorldMatrix: {
                    value: new (0, $ilwiq.Matrix4)()
                },
                invProjectionMatrix: {
                    value: new (0, $ilwiq.Matrix4)()
                },
                // scene uniforms
                bvh: {
                    value: new (0, $3mzmA.MeshBVHUniformStruct)()
                },
                attributesArray: {
                    value: new (0, $6Q19u.AttributesTextureArray)()
                },
                materialIndexAttribute: {
                    value: new (0, $hN8zD.UIntVertexAttributeTexture)()
                },
                materials: {
                    value: new (0, $laA5G.MaterialsTexture)()
                },
                textures: {
                    value: new (0, $12pjC.RenderTarget2DArray)().texture
                },
                // light uniforms
                lights: {
                    value: new (0, $TWVPU.LightsInfoUniformStruct)()
                },
                iesProfiles: {
                    value: new (0, $12pjC.RenderTarget2DArray)(360, 180, {
                        type: (0, $ilwiq.HalfFloatType),
                        wrapS: (0, $ilwiq.ClampToEdgeWrapping),
                        wrapT: (0, $ilwiq.ClampToEdgeWrapping)
                    }).texture
                },
                environmentIntensity: {
                    value: 1.0
                },
                environmentRotation: {
                    value: new (0, $ilwiq.Matrix4)()
                },
                envMapInfo: {
                    value: new (0, $kAJM1.EquirectHdrInfoUniform)()
                },
                // background uniforms
                backgroundBlur: {
                    value: 0.0
                },
                backgroundMap: {
                    value: null
                },
                backgroundAlpha: {
                    value: 1.0
                },
                backgroundIntensity: {
                    value: 1.0
                },
                backgroundRotation: {
                    value: new (0, $ilwiq.Matrix4)()
                },
                // randomness uniforms
                seed: {
                    value: 0
                },
                sobolTexture: {
                    value: null
                },
                stratifiedTexture: {
                    value: new (0, $k5Ikv.StratifiedSamplesTexture)()
                },
                stratifiedOffsetTexture: {
                    value: new (0, $hLXJE.BlueNoiseTexture)(64, 1)
                }
            },
            vertexShader: /* glsl */ `

				varying vec2 vUv;
				void main() {

					vec4 mvPosition = vec4( position, 1.0 );
					mvPosition = modelViewMatrix * mvPosition;
					gl_Position = projectionMatrix * mvPosition;

					vUv = uv;

				}

			`,
            fragmentShader: /* glsl */ `
				#define RAY_OFFSET 1e-4
				#define INFINITY 1e20

				precision highp isampler2D;
				precision highp usampler2D;
				precision highp sampler2DArray;
				vec4 envMapTexelToLinear( vec4 a ) { return a; }
				#include <common>

				// bvh intersection
				${(0, $2vjHu).common_functions}
				${(0, $2vjHu).bvh_struct_definitions}
				${(0, $2vjHu).bvh_ray_functions}

				// uniform structs
				${$sORjD.camera_struct}
				${$1QwjS.lights_struct}
				${$WBvYF.equirect_struct}
				${$1r4sY.material_struct}
				${$asLEI.surface_record_struct}

				// random
				#if RANDOM_TYPE == 2 	// Stratified List

					${$gCBx4.stratified_functions}

				#elif RANDOM_TYPE == 1 	// Sobol

					${$kmALz.pcg_functions}
					${$ffLvN.sobol_common}
					${$ffLvN.sobol_functions}

					#define rand(v) sobol(v)
					#define rand2(v) sobol2(v)
					#define rand3(v) sobol3(v)
					#define rand4(v) sobol4(v)

				#else 					// PCG

				${$kmALz.pcg_functions}

					// Using the sobol functions seems to break the the compiler on MacOS
					// - specifically the "sobolReverseBits" function.
					uint sobolPixelIndex = 0u;
					uint sobolPathIndex = 0u;
					uint sobolBounceIndex = 0u;

					#define rand(v) pcgRand()
					#define rand2(v) pcgRand2()
					#define rand3(v) pcgRand3()
					#define rand4(v) pcgRand4()

				#endif

				// common
				${$jpfro.texture_sample_functions}
				${$8KxWl.fresnel_functions}
				${$dUUQZ.util_functions}
				${$fYvb1.math_functions}
				${$d9skn.shape_intersection_functions}

				// environment
				uniform EquirectHdrInfo envMapInfo;
				uniform mat4 environmentRotation;
				uniform float environmentIntensity;

				// lighting
				uniform sampler2DArray iesProfiles;
				uniform LightsInfo lights;

				// background
				uniform float backgroundBlur;
				uniform float backgroundAlpha;
				#if FEATURE_BACKGROUND_MAP

				uniform sampler2D backgroundMap;
				uniform mat4 backgroundRotation;
				uniform float backgroundIntensity;

				#endif

				// camera
				uniform mat4 cameraWorldMatrix;
				uniform mat4 invProjectionMatrix;
				#if FEATURE_DOF

				uniform PhysicalCamera physicalCamera;

				#endif

				// geometry
				uniform sampler2DArray attributesArray;
				uniform usampler2D materialIndexAttribute;
				uniform sampler2D materials;
				uniform sampler2DArray textures;
				uniform BVH bvh;

				// path tracer
				uniform int bounces;
				uniform int transmissiveBounces;
				uniform float filterGlossyFactor;
				uniform int seed;

				// image
				uniform vec2 resolution;
				uniform float opacity;

				varying vec2 vUv;

				// globals
				mat3 envRotation3x3;
				mat3 invEnvRotation3x3;
				float lightsDenom;

				// sampling
				${$cp6U0.shape_sampling_functions}
				${$6VF8W.equirect_functions}
				${$232IN.light_sampling_functions}

				${$hB5SN.inside_fog_volume_function}
				${$8keuf.ggx_functions}
				${$5SszG.sheen_functions}
				${$9kAYu.iridescence_functions}
				${$4GDCw.fog_functions}
				${$6voD8.bsdf_functions}

				float applyFilteredGlossy( float roughness, float accumulatedRoughness ) {

					return clamp(
						max(
							roughness,
							accumulatedRoughness * filterGlossyFactor * 5.0 ),
						0.0,
						1.0
					);

				}

				vec3 sampleBackground( vec3 direction, vec2 uv ) {

					vec3 sampleDir = sampleHemisphere( direction, uv ) * 0.5 * backgroundBlur;

					#if FEATURE_BACKGROUND_MAP

					sampleDir = normalize( mat3( backgroundRotation ) * direction + sampleDir );
					return backgroundIntensity * sampleEquirectColor( backgroundMap, sampleDir );

					#else

					sampleDir = normalize( envRotation3x3 * direction + sampleDir );
					return environmentIntensity * sampleEquirectColor( envMapInfo.map, sampleDir );

					#endif

				}

				${$ioRiK.render_structs}
				${$eJ3gD.camera_util_functions}
				${$euI5d.trace_scene_function}
				${$1zk7M.attenuate_hit_function}
				${$eZnIg.direct_light_contribution_function}
				${$bwtQK.get_surface_record_function}

				void main() {

					// init
					rng_initialize( gl_FragCoord.xy, seed );
					sobolPixelIndex = ( uint( gl_FragCoord.x ) << 16 ) | uint( gl_FragCoord.y );
					sobolPathIndex = uint( seed );

					// get camera ray
					Ray ray = getCameraRay();

					// inverse environment rotation
					envRotation3x3 = mat3( environmentRotation );
					invEnvRotation3x3 = inverse( envRotation3x3 );
					lightsDenom =
						( environmentIntensity == 0.0 || envMapInfo.totalSum == 0.0 ) && lights.count != 0u ?
							float( lights.count ) :
							float( lights.count + 1u );

					// final color
					gl_FragColor = vec4( 0, 0, 0, 1 );

					// surface results
					SurfaceHit surfaceHit;
					ScatterRecord scatterRec;

					// path tracing state
					RenderState state = initRenderState();
					state.transmissiveTraversals = transmissiveBounces;
					#if FEATURE_FOG

					state.fogMaterial.fogVolume = bvhIntersectFogVolumeHit(
						ray.origin, - ray.direction,
						materialIndexAttribute, materials,
						state.fogMaterial
					);

					#endif

					for ( int i = 0; i < bounces; i ++ ) {

						sobolBounceIndex ++;

						state.depth ++;
						state.traversals = bounces - i;
						state.firstRay = i == 0 && state.transmissiveTraversals == transmissiveBounces;

						int hitType = traceScene( ray, state.fogMaterial, surfaceHit );

						// check if we intersect any lights and accumulate the light contribution
						// TODO: we can add support for light surface rendering in the else condition if we
						// add the ability to toggle visibility of the the light
						if ( ! state.firstRay && ! state.transmissiveRay ) {

							LightRecord lightRec;
							float lightDist = hitType == NO_HIT ? INFINITY : surfaceHit.dist;
							for ( uint i = 0u; i < lights.count; i ++ ) {

								if (
									intersectLightAtIndex( lights.tex, ray.origin, ray.direction, i, lightRec ) &&
									lightRec.dist < lightDist
								) {

									#if FEATURE_MIS

									// weight the contribution
									// NOTE: Only area lights are supported for forward sampling and can be hit
									float misWeight = misHeuristic( scatterRec.pdf, lightRec.pdf / lightsDenom );
									gl_FragColor.rgb += lightRec.emission * state.throughputColor * misWeight;

									#else

									gl_FragColor.rgb += lightRec.emission * state.throughputColor;

									#endif

								}

							}

						}

						if ( hitType == NO_HIT ) {

							if ( state.firstRay || state.transmissiveRay ) {

								gl_FragColor.rgb += sampleBackground( ray.direction, rand2( 2 ) ) * state.throughputColor;
								gl_FragColor.a = backgroundAlpha;

							} else {

								#if FEATURE_MIS

								// get the PDF of the hit envmap point
								vec3 envColor;
								float envPdf = sampleEquirect( envRotation3x3 * ray.direction, envColor );
								envPdf /= lightsDenom;

								// and weight the contribution
								float misWeight = misHeuristic( scatterRec.pdf, envPdf );
								gl_FragColor.rgb += environmentIntensity * envColor * state.throughputColor * misWeight;

								#else

								gl_FragColor.rgb +=
									environmentIntensity *
									sampleEquirectColor( envMapInfo.map, envRotation3x3 * ray.direction ) *
									state.throughputColor;

								#endif

							}
							break;

						}

						uint materialIndex = uTexelFetch1D( materialIndexAttribute, surfaceHit.faceIndices.x ).r;
						Material material = readMaterialInfo( materials, materialIndex );

						#if FEATURE_FOG

						if ( hitType == FOG_HIT ) {

							material = state.fogMaterial;
							state.accumulatedRoughness += 0.2;

						} else if ( material.fogVolume ) {

							state.fogMaterial = material;
							state.fogMaterial.fogVolume = surfaceHit.side == 1.0;

							ray.origin = stepRayOrigin( ray.origin, ray.direction, - surfaceHit.faceNormal, surfaceHit.dist );

							i -= sign( state.transmissiveTraversals );
							state.transmissiveTraversals -= sign( state.transmissiveTraversals );
							continue;

						}

						#endif

						// early out if this is a matte material
						if ( material.matte && state.firstRay ) {

							gl_FragColor = vec4( 0.0 );
							break;

						}

						// if we've determined that this is a shadow ray and we've hit an item with no shadow casting
						// then skip it
						if ( ! material.castShadow && state.isShadowRay ) {

							ray.origin = stepRayOrigin( ray.origin, ray.direction, - surfaceHit.faceNormal, surfaceHit.dist );
							continue;

						}

						SurfaceRecord surf;
						if (
							getSurfaceRecord(
								material, surfaceHit, attributesArray, state.accumulatedRoughness,
								surf
							) == SKIP_SURFACE
						) {

							// only allow a limited number of transparency discards otherwise we could
							// crash the context with too long a loop.
							i -= sign( state.transmissiveTraversals );
							state.transmissiveTraversals -= sign( state.transmissiveTraversals );

							ray.origin = stepRayOrigin( ray.origin, ray.direction, - surfaceHit.faceNormal, surfaceHit.dist );
							continue;

						}

						scatterRec = bsdfSample( - ray.direction, surf );
						state.isShadowRay = scatterRec.specularPdf < rand( 4 );

						bool isBelowSurface = ! surf.volumeParticle && dot( scatterRec.direction, surf.faceNormal ) < 0.0;
						vec3 hitPoint = stepRayOrigin( ray.origin, ray.direction, isBelowSurface ? - surf.faceNormal : surf.faceNormal, surfaceHit.dist );

						// next event estimation
						#if FEATURE_MIS

						gl_FragColor.rgb += directLightContribution( - ray.direction, surf, state, hitPoint );

						#endif

						// accumulate a roughness value to offset diffuse, specular, diffuse rays that have high contribution
						// to a single pixel resulting in fireflies
						// TODO: handle transmissive surfaces
						if ( ! surf.volumeParticle && ! isBelowSurface ) {

							// determine if this is a rough normal or not by checking how far off straight up it is
							vec3 halfVector = normalize( - ray.direction + scatterRec.direction );
							state.accumulatedRoughness += max(
								sin( acosApprox( dot( halfVector, surf.normal ) ) ),
								sin( acosApprox( dot( halfVector, surf.clearcoatNormal ) ) )
							);

							state.transmissiveRay = false;

						}

						// accumulate emissive color
						gl_FragColor.rgb += ( surf.emission * state.throughputColor );

						// skip the sample if our PDF or ray is impossible
						if ( scatterRec.pdf <= 0.0 || ! isDirectionValid( scatterRec.direction, surf.normal, surf.faceNormal ) ) {

							break;

						}

						// if we're bouncing around the inside a transmissive material then decrement
						// perform this separate from a bounce
						bool isTransmissiveRay = ! surf.volumeParticle && dot( scatterRec.direction, surf.faceNormal * surfaceHit.side ) < 0.0;
						if ( ( isTransmissiveRay || isBelowSurface ) && state.transmissiveTraversals > 0 ) {

							state.transmissiveTraversals --;
							i --;

						}

						//

						// handle throughput color transformation
						// attenuate the throughput color by the medium color
						if ( ! surf.frontFace ) {

							state.throughputColor *= transmissionAttenuation( surfaceHit.dist, surf.attenuationColor, surf.attenuationDistance );

						}

						#if FEATURE_RUSSIAN_ROULETTE

						// russian roulette path termination
						// https://www.arnoldrenderer.com/research/physically_based_shader_design_in_arnold.pdf
						uint minBounces = 3u;
						float depthProb = float( state.depth < minBounces );

						float rrProb = luminance( state.throughputColor * scatterRec.color / scatterRec.pdf );
						rrProb /= luminance( state.throughputColor );
						rrProb = sqrt( rrProb );
						rrProb = max( rrProb, depthProb );
						rrProb = min( rrProb, 1.0 );
						if ( rand( 8 ) > rrProb ) {

							break;

						}

						// perform sample clamping here to avoid bright pixels
						state.throughputColor *= min( 1.0 / rrProb, 20.0 );

						#endif

						// adjust the throughput and discard and exit if we find discard the sample if there are any NaNs
						state.throughputColor *= scatterRec.color / scatterRec.pdf;
						if ( any( isnan( state.throughputColor ) ) || any( isinf( state.throughputColor ) ) ) {

							break;

						}

						//

						// prepare for next ray
						ray.direction = scatterRec.direction;
						ray.origin = hitPoint;

					}

					gl_FragColor.a *= opacity;

					#if DEBUG_MODE == 1

					// output the number of rays checked in the path and number of
					// transmissive rays encountered.
					gl_FragColor.rgb = vec3(
						float( state.depth ),
						transmissiveBounces - state.transmissiveTraversals,
						0.0
					);
					gl_FragColor.a = 1.0;

					#endif

				}

			`
        });
        this.setValues(parameters);
    }
}

});
parcelRegister("iyhQ7", function(module, exports) {

$parcel$export(module.exports, "PhysicalCameraUniform", () => $d8193d8a8d6141d1$export$2e27c77dea3c9d73);

var $kLfIo = parcelRequire("kLfIo");
class $d8193d8a8d6141d1$export$2e27c77dea3c9d73 {
    constructor(){
        this.bokehSize = 0;
        this.apertureBlades = 0;
        this.apertureRotation = 0;
        this.focusDistance = 10;
        this.anamorphicRatio = 1;
    }
    updateFrom(camera) {
        if (camera instanceof (0, $kLfIo.PhysicalCamera)) {
            this.bokehSize = camera.bokehSize;
            this.apertureBlades = camera.apertureBlades;
            this.apertureRotation = camera.apertureRotation;
            this.focusDistance = camera.focusDistance;
            this.anamorphicRatio = camera.anamorphicRatio;
        } else {
            this.bokehSize = 0;
            this.apertureRotation = 0;
            this.apertureBlades = 0;
            this.focusDistance = 10;
            this.anamorphicRatio = 1;
        }
    }
}

});
parcelRegister("kLfIo", function(module, exports) {

$parcel$export(module.exports, "PhysicalCamera", () => $f1d46319b05d893e$export$baf85f88dacad6d5);

var $ilwiq = parcelRequire("ilwiq");
class $f1d46319b05d893e$export$baf85f88dacad6d5 extends (0, $ilwiq.PerspectiveCamera) {
    set bokehSize(size) {
        this.fStop = this.getFocalLength() / size;
    }
    get bokehSize() {
        return this.getFocalLength() / this.fStop;
    }
    constructor(...args){
        super(...args);
        this.fStop = 1.4;
        this.apertureBlades = 0;
        this.apertureRotation = 0;
        this.focusDistance = 25;
        this.anamorphicRatio = 1;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fStop = source.fStop;
        this.apertureBlades = source.apertureBlades;
        this.apertureRotation = source.apertureRotation;
        this.focusDistance = source.focusDistance;
        this.anamorphicRatio = source.anamorphicRatio;
        return this;
    }
}

});


parcelRegister("kAJM1", function(module, exports) {

$parcel$export(module.exports, "EquirectHdrInfoUniform", () => $efdaad16b8cd905b$export$e5a77e5d6a85a862);

var $ilwiq = parcelRequire("ilwiq");

var $2vGrm = parcelRequire("2vGrm");
function $efdaad16b8cd905b$var$binarySearchFindClosestIndexOf(array, targetValue, offset = 0, count = array.length) {
    let lower = offset;
    let upper = offset + count - 1;
    while(lower < upper){
        // calculate the midpoint for this iteration using a bitwise shift right operator to save 1 floating point multiplication
        // and 1 truncation from the double tilde operator to improve performance
        // this results in much better performance over using standard "~ ~ ( (lower + upper) ) / 2" to calculate the midpoint
        const mid = lower + upper >> 1;
        // check if the middle array value is above or below the target and shift
        // which half of the array we're looking at
        if (array[mid] < targetValue) lower = mid + 1;
        else upper = mid;
    }
    return lower - offset;
}
function $efdaad16b8cd905b$var$colorToLuminance(r, g, b) {
    // https://en.wikipedia.org/wiki/Relative_luminance
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
// ensures the data is all floating point values and flipY is false
function $efdaad16b8cd905b$var$preprocessEnvMap(envMap, targetType = (0, $ilwiq.HalfFloatType)) {
    const map = envMap.clone();
    map.source = new (0, $ilwiq.Source)({
        ...map.image
    });
    const { width: width, height: height, data: data } = map.image;
    // TODO: is there a simple way to avoid cloning and adjusting the env map data here?
    // convert the data from half float uint 16 arrays to float arrays for cdf computation
    let newData = data;
    if (map.type !== targetType) {
        if (targetType === (0, $ilwiq.HalfFloatType)) newData = new Uint16Array(data.length);
        else newData = new Float32Array(data.length);
        let maxIntValue;
        if (data instanceof Int8Array || data instanceof Int16Array || data instanceof Int32Array) maxIntValue = 2 ** (8 * data.BYTES_PER_ELEMENT - 1) - 1;
        else maxIntValue = 2 ** (8 * data.BYTES_PER_ELEMENT) - 1;
        for(let i = 0, l = data.length; i < l; i++){
            let v = data[i];
            if (map.type === (0, $ilwiq.HalfFloatType)) v = (0, $ilwiq.DataUtils).fromHalfFloat(data[i]);
            if (map.type !== (0, $ilwiq.FloatType) && map.type !== (0, $ilwiq.HalfFloatType)) v /= maxIntValue;
            if (targetType === (0, $ilwiq.HalfFloatType)) newData[i] = (0, $ilwiq.DataUtils).toHalfFloat(v);
        }
        map.image.data = newData;
        map.type = targetType;
    }
    // remove any y flipping for cdf computation
    if (map.flipY) {
        const ogData = newData;
        newData = newData.slice();
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const newY = height - y - 1;
            const ogIndex = 4 * (y * width + x);
            const newIndex = 4 * (newY * width + x);
            newData[newIndex + 0] = ogData[ogIndex + 0];
            newData[newIndex + 1] = ogData[ogIndex + 1];
            newData[newIndex + 2] = ogData[ogIndex + 2];
            newData[newIndex + 3] = ogData[ogIndex + 3];
        }
        map.flipY = false;
        map.image.data = newData;
    }
    return map;
}
class $efdaad16b8cd905b$export$e5a77e5d6a85a862 {
    constructor(){
        // Default to a white texture and associated weights so we don't
        // just render black initially.
        const blackTex = new (0, $ilwiq.DataTexture)((0, $2vGrm.toHalfFloatArray)(new Float32Array([
            0,
            0,
            0,
            0
        ])), 1, 1);
        blackTex.type = (0, $ilwiq.HalfFloatType);
        blackTex.format = (0, $ilwiq.RGBAFormat);
        blackTex.minFilter = (0, $ilwiq.LinearFilter);
        blackTex.magFilter = (0, $ilwiq.LinearFilter);
        blackTex.wrapS = (0, $ilwiq.RepeatWrapping);
        blackTex.wrapT = (0, $ilwiq.RepeatWrapping);
        blackTex.generateMipmaps = false;
        blackTex.needsUpdate = true;
        // Stores a map of [0, 1] value -> cumulative importance row & pdf
        // used to sampling a random value to a relevant row to sample from
        const marginalWeights = new (0, $ilwiq.DataTexture)((0, $2vGrm.toHalfFloatArray)(new Float32Array([
            0,
            1
        ])), 1, 2);
        marginalWeights.type = (0, $ilwiq.HalfFloatType);
        marginalWeights.format = (0, $ilwiq.RedFormat);
        marginalWeights.minFilter = (0, $ilwiq.LinearFilter);
        marginalWeights.magFilter = (0, $ilwiq.LinearFilter);
        marginalWeights.generateMipmaps = false;
        marginalWeights.needsUpdate = true;
        // Stores a map of [0, 1] value -> cumulative importance column & pdf
        // used to sampling a random value to a relevant pixel to sample from
        const conditionalWeights = new (0, $ilwiq.DataTexture)((0, $2vGrm.toHalfFloatArray)(new Float32Array([
            0,
            0,
            1,
            1
        ])), 2, 2);
        conditionalWeights.type = (0, $ilwiq.HalfFloatType);
        conditionalWeights.format = (0, $ilwiq.RedFormat);
        conditionalWeights.minFilter = (0, $ilwiq.LinearFilter);
        conditionalWeights.magFilter = (0, $ilwiq.LinearFilter);
        conditionalWeights.generateMipmaps = false;
        conditionalWeights.needsUpdate = true;
        this.map = blackTex;
        this.marginalWeights = marginalWeights;
        this.conditionalWeights = conditionalWeights;
        this.totalSum = 0;
    // TODO: Add support for float or half float types here. We need to pass this into
    // the preprocess function and ensure our CDF and MDF textures are appropriately sized
    // Ideally we wouldn't upscale a bit depth if we didn't need to.
    // this.type = HalfFloatType;
    }
    dispose() {
        this.marginalWeights.dispose();
        this.conditionalWeights.dispose();
        this.map.dispose();
    }
    updateFrom(hdr) {
        // https://github.com/knightcrawler25/GLSL-PathTracer/blob/3c6fd9b6b3da47cd50c527eeb45845eef06c55c3/src/loaders/hdrloader.cpp
        // https://pbr-book.org/3ed-2018/Light_Transport_I_Surface_Reflection/Sampling_Light_Sources#InfiniteAreaLights
        const map = $efdaad16b8cd905b$var$preprocessEnvMap(hdr);
        map.wrapS = (0, $ilwiq.RepeatWrapping);
        map.wrapT = (0, $ilwiq.ClampToEdgeWrapping);
        const { width: width, height: height, data: data } = map.image;
        // "conditional" = "pixel relative to row pixels sum"
        // "marginal" = "row relative to row sum"
        // track the importance of any given pixel in the image by tracking its weight relative to other pixels in the image
        const pdfConditional = new Float32Array(width * height);
        const cdfConditional = new Float32Array(width * height);
        const pdfMarginal = new Float32Array(height);
        const cdfMarginal = new Float32Array(height);
        let totalSumValue = 0.0;
        let cumulativeWeightMarginal = 0.0;
        for(let y = 0; y < height; y++){
            let cumulativeRowWeight = 0.0;
            for(let x = 0; x < width; x++){
                const i = y * width + x;
                const r = (0, $ilwiq.DataUtils).fromHalfFloat(data[4 * i + 0]);
                const g = (0, $ilwiq.DataUtils).fromHalfFloat(data[4 * i + 1]);
                const b = (0, $ilwiq.DataUtils).fromHalfFloat(data[4 * i + 2]);
                // the probability of the pixel being selected in this row is the
                // scale of the luminance relative to the rest of the pixels.
                // TODO: this should also account for the solid angle of the pixel when sampling
                const weight = $efdaad16b8cd905b$var$colorToLuminance(r, g, b);
                cumulativeRowWeight += weight;
                totalSumValue += weight;
                pdfConditional[i] = weight;
                cdfConditional[i] = cumulativeRowWeight;
            }
            // can happen if the row is all black
            if (cumulativeRowWeight !== 0) // scale the pdf and cdf to [0.0, 1.0]
            for(let i = y * width, l = y * width + width; i < l; i++){
                pdfConditional[i] /= cumulativeRowWeight;
                cdfConditional[i] /= cumulativeRowWeight;
            }
            cumulativeWeightMarginal += cumulativeRowWeight;
            // compute the marginal pdf and cdf along the height of the map.
            pdfMarginal[y] = cumulativeRowWeight;
            cdfMarginal[y] = cumulativeWeightMarginal;
        }
        // can happen if the texture is all black
        if (cumulativeWeightMarginal !== 0) // scale the marginal pdf and cdf to [0.0, 1.0]
        for(let i = 0, l = pdfMarginal.length; i < l; i++){
            pdfMarginal[i] /= cumulativeWeightMarginal;
            cdfMarginal[i] /= cumulativeWeightMarginal;
        }
        // compute a sorted index of distributions and the probabilities along them for both
        // the marginal and conditional data. These will be used to sample with a random number
        // to retrieve a uv value to sample in the environment map.
        // These values continually increase so it's okay to interpolate between them.
        const marginalDataArray = new Uint16Array(height);
        const conditionalDataArray = new Uint16Array(width * height);
        // we add a half texel offset so we're sampling the center of the pixel
        for(let i = 0; i < height; i++){
            const dist = (i + 1) / height;
            const row = $efdaad16b8cd905b$var$binarySearchFindClosestIndexOf(cdfMarginal, dist);
            marginalDataArray[i] = (0, $ilwiq.DataUtils).toHalfFloat((row + 0.5) / height);
        }
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const i = y * width + x;
            const dist = (x + 1) / width;
            const col = $efdaad16b8cd905b$var$binarySearchFindClosestIndexOf(cdfConditional, dist, y * width, width);
            conditionalDataArray[i] = (0, $ilwiq.DataUtils).toHalfFloat((col + 0.5) / width);
        }
        this.dispose();
        const { marginalWeights: marginalWeights, conditionalWeights: conditionalWeights } = this;
        marginalWeights.image = {
            width: height,
            height: 1,
            data: marginalDataArray
        };
        marginalWeights.needsUpdate = true;
        conditionalWeights.image = {
            width: width,
            height: height,
            data: conditionalDataArray
        };
        conditionalWeights.needsUpdate = true;
        this.totalSum = totalSumValue;
        this.map = map;
    }
}

});
parcelRegister("2vGrm", function(module, exports) {

$parcel$export(module.exports, "toHalfFloatArray", () => $1d3f65c6c5f4f52a$export$8090c803d9d233c2);

var $ilwiq = parcelRequire("ilwiq");
function $1d3f65c6c5f4f52a$export$8090c803d9d233c2(f32Array) {
    const f16Array = new Uint16Array(f32Array.length);
    for(let i = 0, n = f32Array.length; i < n; ++i)f16Array[i] = (0, $ilwiq.DataUtils).toHalfFloat(f32Array[i]);
    return f16Array;
}

});


parcelRegister("TWVPU", function(module, exports) {

$parcel$export(module.exports, "LightsInfoUniformStruct", () => $0a82d9ce12cf98b8$export$bb02c0eb15767758);

var $ilwiq = parcelRequire("ilwiq");

var $6ply6 = parcelRequire("6ply6");
const $0a82d9ce12cf98b8$var$LIGHT_PIXELS = 6;
const $0a82d9ce12cf98b8$var$RECT_AREA_LIGHT = 0;
const $0a82d9ce12cf98b8$var$CIRC_AREA_LIGHT = 1;
const $0a82d9ce12cf98b8$var$SPOT_LIGHT = 2;
const $0a82d9ce12cf98b8$var$DIR_LIGHT = 3;
const $0a82d9ce12cf98b8$var$POINT_LIGHT = 4;
const $0a82d9ce12cf98b8$var$u = new (0, $ilwiq.Vector3)();
const $0a82d9ce12cf98b8$var$v = new (0, $ilwiq.Vector3)();
const $0a82d9ce12cf98b8$var$m = new (0, $ilwiq.Matrix4)();
const $0a82d9ce12cf98b8$var$worldQuaternion = new (0, $ilwiq.Quaternion)();
const $0a82d9ce12cf98b8$var$eye = new (0, $ilwiq.Vector3)();
const $0a82d9ce12cf98b8$var$target = new (0, $ilwiq.Vector3)();
const $0a82d9ce12cf98b8$var$up = new (0, $ilwiq.Vector3)(0, 1, 0);
class $0a82d9ce12cf98b8$export$bb02c0eb15767758 {
    constructor(){
        const tex = new (0, $ilwiq.DataTexture)(new Float32Array(4), 1, 1);
        tex.format = (0, $ilwiq.RGBAFormat);
        tex.type = (0, $ilwiq.FloatType);
        tex.wrapS = (0, $ilwiq.ClampToEdgeWrapping);
        tex.wrapT = (0, $ilwiq.ClampToEdgeWrapping);
        tex.generateMipmaps = false;
        tex.minFilter = (0, $ilwiq.NearestFilter);
        tex.magFilter = (0, $ilwiq.NearestFilter);
        this.tex = tex;
        this.count = 0;
    }
    updateFrom(lights, iesTextures = []) {
        const tex = this.tex;
        const pixelCount = Math.max(lights.length * $0a82d9ce12cf98b8$var$LIGHT_PIXELS, 1);
        const dimension = Math.ceil(Math.sqrt(pixelCount));
        if (tex.image.width !== dimension) {
            tex.dispose();
            tex.image.data = new Float32Array(dimension * dimension * 4);
            tex.image.width = dimension;
            tex.image.height = dimension;
        }
        const floatArray = tex.image.data;
        for(let i = 0, l = lights.length; i < l; i++){
            const l = lights[i];
            const baseIndex = i * $0a82d9ce12cf98b8$var$LIGHT_PIXELS * 4;
            let index = 0;
            // initialize to 0
            for(let p = 0; p < $0a82d9ce12cf98b8$var$LIGHT_PIXELS * 4; p++)floatArray[baseIndex + p] = 0;
            // sample 1
            // position
            l.getWorldPosition($0a82d9ce12cf98b8$var$v);
            floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.x;
            floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.y;
            floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.z;
            // type
            let type = $0a82d9ce12cf98b8$var$RECT_AREA_LIGHT;
            if (l.isRectAreaLight && l.isCircular) type = $0a82d9ce12cf98b8$var$CIRC_AREA_LIGHT;
            else if (l.isSpotLight) type = $0a82d9ce12cf98b8$var$SPOT_LIGHT;
            else if (l.isDirectionalLight) type = $0a82d9ce12cf98b8$var$DIR_LIGHT;
            else if (l.isPointLight) type = $0a82d9ce12cf98b8$var$POINT_LIGHT;
            floatArray[baseIndex + index++] = type;
            // sample 2
            // color
            floatArray[baseIndex + index++] = l.color.r;
            floatArray[baseIndex + index++] = l.color.g;
            floatArray[baseIndex + index++] = l.color.b;
            // intensity
            floatArray[baseIndex + index++] = l.intensity;
            l.getWorldQuaternion($0a82d9ce12cf98b8$var$worldQuaternion);
            if (l.isRectAreaLight) {
                // sample 3
                // u vector
                $0a82d9ce12cf98b8$var$u.set(l.width, 0, 0).applyQuaternion($0a82d9ce12cf98b8$var$worldQuaternion);
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$u.x;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$u.y;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$u.z;
                index++;
                // sample 4
                // v vector
                $0a82d9ce12cf98b8$var$v.set(0, l.height, 0).applyQuaternion($0a82d9ce12cf98b8$var$worldQuaternion);
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.x;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.y;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.z;
                // area
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$u.cross($0a82d9ce12cf98b8$var$v).length() * (l.isCircular ? Math.PI / 4.0 : 1.0);
            } else if (l.isSpotLight) {
                const radius = l.radius || 0;
                $0a82d9ce12cf98b8$var$eye.setFromMatrixPosition(l.matrixWorld);
                $0a82d9ce12cf98b8$var$target.setFromMatrixPosition(l.target.matrixWorld);
                $0a82d9ce12cf98b8$var$m.lookAt($0a82d9ce12cf98b8$var$eye, $0a82d9ce12cf98b8$var$target, $0a82d9ce12cf98b8$var$up);
                $0a82d9ce12cf98b8$var$worldQuaternion.setFromRotationMatrix($0a82d9ce12cf98b8$var$m);
                // sample 3
                // u vector
                $0a82d9ce12cf98b8$var$u.set(1, 0, 0).applyQuaternion($0a82d9ce12cf98b8$var$worldQuaternion);
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$u.x;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$u.y;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$u.z;
                index++;
                // sample 4
                // v vector
                $0a82d9ce12cf98b8$var$v.set(0, 1, 0).applyQuaternion($0a82d9ce12cf98b8$var$worldQuaternion);
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.x;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.y;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$v.z;
                // area
                floatArray[baseIndex + index++] = Math.PI * radius * radius;
                // sample 5
                // radius
                floatArray[baseIndex + index++] = radius;
                // decay
                floatArray[baseIndex + index++] = l.decay;
                // distance
                floatArray[baseIndex + index++] = l.distance;
                // coneCos
                floatArray[baseIndex + index++] = Math.cos(l.angle);
                // sample 6
                // penumbraCos
                floatArray[baseIndex + index++] = Math.cos(l.angle * (1 - l.penumbra));
                // iesProfile
                floatArray[baseIndex + index++] = l.iesMap ? iesTextures.indexOf(l.iesMap) : -1;
            } else if (l.isPointLight) {
                const worldPosition = $0a82d9ce12cf98b8$var$u.setFromMatrixPosition(l.matrixWorld);
                // sample 3
                // u vector
                floatArray[baseIndex + index++] = worldPosition.x;
                floatArray[baseIndex + index++] = worldPosition.y;
                floatArray[baseIndex + index++] = worldPosition.z;
                index++;
                // sample 4
                index += 4;
                // sample 5
                index += 1;
                floatArray[baseIndex + index++] = l.decay;
                floatArray[baseIndex + index++] = l.distance;
            } else if (l.isDirectionalLight) {
                const worldPosition = $0a82d9ce12cf98b8$var$u.setFromMatrixPosition(l.matrixWorld);
                const targetPosition = $0a82d9ce12cf98b8$var$v.setFromMatrixPosition(l.target.matrixWorld);
                $0a82d9ce12cf98b8$var$target.subVectors(worldPosition, targetPosition).normalize();
                // sample 3
                // u vector
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$target.x;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$target.y;
                floatArray[baseIndex + index++] = $0a82d9ce12cf98b8$var$target.z;
            }
        }
        this.count = lights.length;
        const hash = (0, $6ply6.bufferToHash)(floatArray.buffer);
        if (this.hash !== hash) {
            this.hash = hash;
            tex.needsUpdate = true;
            return true;
        }
        return false;
    }
}

});

parcelRegister("6Q19u", function(module, exports) {

$parcel$export(module.exports, "AttributesTextureArray", () => $4fa87e2831d7f36b$export$2e089d4ee1364df8);

var $7Ie7O = parcelRequire("7Ie7O");
class $4fa87e2831d7f36b$export$2e089d4ee1364df8 extends (0, $7Ie7O.FloatAttributeTextureArray) {
    updateNormalAttribute(attr) {
        this.updateAttribute(0, attr);
    }
    updateTangentAttribute(attr) {
        this.updateAttribute(1, attr);
    }
    updateUvAttribute(attr) {
        this.updateAttribute(2, attr);
    }
    updateColorAttribute(attr) {
        this.updateAttribute(3, attr);
    }
    updateFrom(normal, tangent, uv, color) {
        this.setAttributes([
            normal,
            tangent,
            uv,
            color
        ]);
    }
}

});
parcelRegister("7Ie7O", function(module, exports) {

$parcel$export(module.exports, "FloatAttributeTextureArray", () => $59d79964e8fc761c$export$74918e5550c6edfc);

var $ilwiq = parcelRequire("ilwiq");

var $hN8zD = parcelRequire("hN8zD");
function $59d79964e8fc761c$var$copyArrayToArray(fromArray, fromStride, toArray, toStride, offset) {
    if (fromStride > toStride) throw new Error();
    // scale non-float values to their normalized range
    const count = fromArray.length / fromStride;
    const bpe = fromArray.constructor.BYTES_PER_ELEMENT * 8;
    let maxValue = 1.0;
    switch(fromArray.constructor){
        case Uint8Array:
        case Uint16Array:
        case Uint32Array:
            maxValue = 2 ** bpe - 1;
            break;
        case Int8Array:
        case Int16Array:
        case Int32Array:
            maxValue = 2 ** (bpe - 1) - 1;
            break;
    }
    for(let i = 0; i < count; i++){
        const i4 = 4 * i;
        const is = fromStride * i;
        for(let j = 0; j < toStride; j++)toArray[offset + i4 + j] = fromStride >= j + 1 ? fromArray[is + j] / maxValue : 0;
    }
}
class $59d79964e8fc761c$export$74918e5550c6edfc extends (0, $ilwiq.DataArrayTexture) {
    constructor(){
        super();
        this._textures = [];
        this.type = (0, $ilwiq.FloatType);
        this.format = (0, $ilwiq.RGBAFormat);
        this.internalFormat = "RGBA32F";
    }
    updateAttribute(index, attr) {
        // update the texture
        const tex = this._textures[index];
        tex.updateFrom(attr);
        // ensure compatibility
        const baseImage = tex.image;
        const image = this.image;
        if (baseImage.width !== image.width || baseImage.height !== image.height) throw new Error("FloatAttributeTextureArray: Attribute must be the same dimensions when updating single layer.");
        // update the image
        const { width: width, height: height, data: data } = image;
        const length = width * height * 4;
        const offset = length * index;
        let itemSize = attr.itemSize;
        if (itemSize === 3) itemSize = 4;
        // copy the data
        $59d79964e8fc761c$var$copyArrayToArray(tex.image.data, itemSize, data, 4, offset);
        this.dispose();
        this.needsUpdate = true;
    }
    setAttributes(attrs) {
        // ensure the attribute count
        const itemCount = attrs[0].count;
        const attrsLength = attrs.length;
        for(let i = 0, l = attrsLength; i < l; i++){
            if (attrs[i].count !== itemCount) throw new Error("FloatAttributeTextureArray: All attributes must have the same item count.");
        }
        // initialize all textures
        const textures = this._textures;
        while(textures.length < attrsLength){
            const tex = new (0, $hN8zD.FloatVertexAttributeTexture)();
            textures.push(tex);
        }
        while(textures.length > attrsLength)textures.pop();
        // update all textures
        for(let i = 0, l = attrsLength; i < l; i++)textures[i].updateFrom(attrs[i]);
        // determine if we need to create a new array
        const baseTexture = textures[0];
        const baseImage = baseTexture.image;
        const image = this.image;
        if (baseImage.width !== image.width || baseImage.height !== image.height || baseImage.depth !== attrsLength) {
            image.width = baseImage.width;
            image.height = baseImage.height;
            image.depth = attrsLength;
            image.data = new Float32Array(image.width * image.height * image.depth * 4);
        }
        // copy the other texture data into the data array texture
        const { data: data, width: width, height: height } = image;
        for(let i = 0, l = attrsLength; i < l; i++){
            const tex = textures[i];
            const length = width * height * 4;
            const offset = length * i;
            let itemSize = attrs[i].itemSize;
            if (itemSize === 3) itemSize = 4;
            $59d79964e8fc761c$var$copyArrayToArray(tex.image.data, itemSize, data, 4, offset);
        }
        // reset the texture
        this.dispose();
        this.needsUpdate = true;
    }
}

});


parcelRegister("12pjC", function(module, exports) {

$parcel$export(module.exports, "RenderTarget2DArray", () => $0c199d70d276a61d$export$dbbaa51cb2d0b2f7);

var $ilwiq = parcelRequire("ilwiq");

var $RPVlj = parcelRequire("RPVlj");
const $0c199d70d276a61d$var$prevColor = new (0, $ilwiq.Color)();
function $0c199d70d276a61d$var$getTextureHash(texture) {
    return texture ? `${texture.uuid}:${texture.version}` : null;
}
function $0c199d70d276a61d$var$assignOptions(target, options) {
    for(const key in options)if (key in target) target[key] = options[key];
}
class $0c199d70d276a61d$export$dbbaa51cb2d0b2f7 extends (0, $ilwiq.WebGLArrayRenderTarget) {
    constructor(width, height, options){
        const textureOptions = {
            format: (0, $ilwiq.RGBAFormat),
            type: (0, $ilwiq.UnsignedByteType),
            minFilter: (0, $ilwiq.LinearFilter),
            magFilter: (0, $ilwiq.LinearFilter),
            wrapS: (0, $ilwiq.RepeatWrapping),
            wrapT: (0, $ilwiq.RepeatWrapping),
            generateMipmaps: false,
            ...options
        };
        super(width, height, 1, textureOptions);
        // manually assign the options because passing options into the
        // constructor does not work
        $0c199d70d276a61d$var$assignOptions(this.texture, textureOptions);
        this.texture.setTextures = (...args)=>{
            this.setTextures(...args);
        };
        this.hashes = [
            null
        ];
        const fsQuad = new (0, $RPVlj.FullScreenQuad)(new $0c199d70d276a61d$var$CopyMaterial());
        this.fsQuad = fsQuad;
    }
    setTextures(renderer, textures, width = this.width, height = this.height) {
        // save previous renderer state
        const prevRenderTarget = renderer.getRenderTarget();
        const prevToneMapping = renderer.toneMapping;
        const prevAlpha = renderer.getClearAlpha();
        renderer.getClearColor($0c199d70d276a61d$var$prevColor);
        // resize the render target and ensure we don't have an empty texture
        // render target depth must be >= 1 to avoid unbound texture error on android devices
        const depth = textures.length || 1;
        if (width !== this.width || height !== this.height || this.depth !== depth) {
            this.setSize(width, height, depth);
            this.hashes = new Array(depth).fill(null);
        }
        renderer.setClearColor(0, 0);
        renderer.toneMapping = (0, $ilwiq.NoToneMapping);
        // render each texture into each layer of the target
        const fsQuad = this.fsQuad;
        const hashes = this.hashes;
        let updated = false;
        for(let i = 0, l = depth; i < l; i++){
            const texture = textures[i];
            const hash = $0c199d70d276a61d$var$getTextureHash(texture);
            if (texture && (hashes[i] !== hash || texture.isWebGLRenderTarget)) {
                // revert to default texture transform before rendering
                texture.matrixAutoUpdate = false;
                texture.matrix.identity();
                fsQuad.material.map = texture;
                renderer.setRenderTarget(this, i);
                fsQuad.render(renderer);
                // restore custom texture transform
                texture.updateMatrix();
                texture.matrixAutoUpdate = true;
                // ensure textures are not updated unnecessarily
                hashes[i] = hash;
                updated = true;
            }
        }
        // reset the renderer
        fsQuad.material.map = null;
        renderer.setClearColor($0c199d70d276a61d$var$prevColor, prevAlpha);
        renderer.setRenderTarget(prevRenderTarget);
        renderer.toneMapping = prevToneMapping;
        return updated;
    }
    dispose() {
        super.dispose();
        this.fsQuad.dispose();
    }
}
class $0c199d70d276a61d$var$CopyMaterial extends (0, $ilwiq.ShaderMaterial) {
    get map() {
        return this.uniforms.map.value;
    }
    set map(v) {
        this.uniforms.map.value = v;
    }
    constructor(){
        super({
            uniforms: {
                map: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `
				varying vec2 vUv;
				void main() {

					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

				}
			`,
            fragmentShader: /* glsl */ `
				uniform sampler2D map;
				varying vec2 vUv;
				void main() {

					gl_FragColor = texture2D( map, vUv );

				}
			`
        });
    }
}

});

parcelRegister("k5Ikv", function(module, exports) {

$parcel$export(module.exports, "StratifiedSamplesTexture", () => $ea06a939ea8d5f41$export$ed86923a2d1cdb9);

var $ilwiq = parcelRequire("ilwiq");

var $50JN2 = parcelRequire("50JN2");
// https://stackoverflow.com/questions/424292/seedable-javascript-random-number-generator
class $ea06a939ea8d5f41$var$RandomGenerator {
    constructor(seed = 0){
        // LCG using GCC's constants
        this.m = 0x80000000; // 2**31;
        this.a = 1103515245;
        this.c = 12345;
        this.seed = seed;
    }
    nextInt() {
        this.seed = (this.a * this.seed + this.c) % this.m;
        return this.seed;
    }
    nextFloat() {
        // returns in range [0,1]
        return this.nextInt() / (this.m - 1);
    }
}
class $ea06a939ea8d5f41$export$ed86923a2d1cdb9 extends (0, $ilwiq.DataTexture) {
    constructor(count = 1, depth = 1, strata = 8){
        super(new Float32Array(1), 1, 1, (0, $ilwiq.RGBAFormat), (0, $ilwiq.FloatType));
        this.minFilter = (0, $ilwiq.NearestFilter);
        this.magFilter = (0, $ilwiq.NearestFilter);
        this.strata = strata;
        this.sampler = null;
        this.generator = new $ea06a939ea8d5f41$var$RandomGenerator();
        this.stableNoise = false;
        this.random = ()=>{
            if (this.stableNoise) return this.generator.nextFloat();
            else return Math.random();
        };
        this.init(count, depth, strata);
    }
    init(count = this.image.height, depth = this.image.width, strata = this.strata) {
        const { image: image } = this;
        if (image.width === depth && image.height === count && this.sampler !== null) return;
        const dimensions = new Array(count * depth).fill(4);
        const sampler = new (0, $50JN2.StratifiedSamplerCombined)(strata, dimensions, this.random);
        image.width = depth;
        image.height = count;
        image.data = sampler.samples;
        this.sampler = sampler;
        this.dispose();
        this.next();
    }
    next() {
        this.sampler.next();
        this.needsUpdate = true;
    }
    reset() {
        this.sampler.reset();
        this.generator.seed = 0;
    }
}

});
parcelRegister("50JN2", function(module, exports) {

$parcel$export(module.exports, "StratifiedSamplerCombined", () => $3a6078c8a44ac239$export$ec2d5f3091da4863);
// Stratified Sampling based on implementation from hoverinc pathtracer
// - https://github.com/hoverinc/ray-tracing-renderer
// - http://www.pbr-book.org/3ed-2018/Sampling_and_Reconstruction/Stratified_Sampling.html

var $1mKfc = parcelRequire("1mKfc");
class $3a6078c8a44ac239$export$ec2d5f3091da4863 {
    constructor(strataCount, listOfDimensions, random = Math.random){
        let totalDim = 0;
        for (const dim of listOfDimensions)totalDim += dim;
        const combined = new Float32Array(totalDim);
        const strataObjs = [];
        let offset = 0;
        for (const dim of listOfDimensions){
            const sampler = new (0, $1mKfc.StratifiedSampler)(strataCount, dim, random);
            sampler.samples = new Float32Array(combined.buffer, offset, sampler.samples.length);
            offset += sampler.samples.length * 4;
            strataObjs.push(sampler);
        }
        this.samples = combined;
        this.strataCount = strataCount;
        this.next = function() {
            for (const strata of strataObjs)strata.next();
            return combined;
        };
        this.reshuffle = function() {
            for (const strata of strataObjs)strata.reshuffle();
        };
        this.reset = function() {
            for (const strata of strataObjs)strata.reset();
        };
    }
}

});
parcelRegister("1mKfc", function(module, exports) {

$parcel$export(module.exports, "StratifiedSampler", () => $0febb7a1dd1bc005$export$4811b65fd3eaefe6);
// Stratified Sampling based on implementation from hoverinc pathtracer
// - https://github.com/hoverinc/ray-tracing-renderer
// - http://www.pbr-book.org/3ed-2018/Sampling_and_Reconstruction/Stratified_Sampling.html
function $0febb7a1dd1bc005$export$448332262467e042(arr, random = Math.random()) {
    for(let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(random() * (i + 1));
        const x = arr[i];
        arr[i] = arr[j];
        arr[j] = x;
    }
    return arr;
}
class $0febb7a1dd1bc005$export$4811b65fd3eaefe6 {
    constructor(strataCount, dimensions, random = Math.random){
        const l = strataCount ** dimensions;
        const strata = new Uint16Array(l);
        let index = l;
        // each integer represents a statum bin
        for(let i = 0; i < l; i++)strata[i] = i;
        this.samples = new Float32Array(dimensions);
        this.strataCount = strataCount;
        this.reset = function() {
            for(let i = 0; i < l; i++)strata[i] = i;
            index = 0;
        };
        this.reshuffle = function() {
            index = 0;
        };
        this.next = function() {
            const { samples: samples } = this;
            if (index >= strata.length) {
                $0febb7a1dd1bc005$export$448332262467e042(strata, random);
                this.reshuffle();
            }
            let stratum = strata[index++];
            for(let i = 0; i < dimensions; i++){
                samples[i] = (stratum % strataCount + random()) / strataCount;
                stratum = Math.floor(stratum / strataCount);
            }
            return samples;
        };
    }
}

});



parcelRegister("hLXJE", function(module, exports) {

$parcel$export(module.exports, "BlueNoiseTexture", () => $cf0529a3c8d7a87e$export$df8ca2ad0d82597a);

var $ilwiq = parcelRequire("ilwiq");

var $7Afqk = parcelRequire("7Afqk");
function $cf0529a3c8d7a87e$var$getStride(channels) {
    if (channels >= 3) return 4;
    else return channels;
}
function $cf0529a3c8d7a87e$var$getFormat(channels) {
    switch(channels){
        case 1:
            return 0, $ilwiq.RedFormat;
        case 2:
            return 0, $ilwiq.RGFormat;
        default:
            return 0, $ilwiq.RGBAFormat;
    }
}
class $cf0529a3c8d7a87e$export$df8ca2ad0d82597a extends (0, $ilwiq.DataTexture) {
    constructor(size = 64, channels = 1){
        super(new Float32Array(4), 1, 1, (0, $ilwiq.RGBAFormat), (0, $ilwiq.FloatType));
        this.minFilter = (0, $ilwiq.NearestFilter);
        this.magFilter = (0, $ilwiq.NearestFilter);
        this.size = size;
        this.channels = channels;
        this.update();
    }
    update() {
        const channels = this.channels;
        const size = this.size;
        const generator = new (0, $7Afqk.BlueNoiseGenerator)();
        generator.channels = channels;
        generator.size = size;
        const stride = $cf0529a3c8d7a87e$var$getStride(channels);
        const format = $cf0529a3c8d7a87e$var$getFormat(stride);
        if (this.image.width !== size || format !== this.format) {
            this.image.width = size;
            this.image.height = size;
            this.image.data = new Float32Array(size ** 2 * stride);
            this.format = format;
            this.dispose();
        }
        const data = this.image.data;
        for(let i = 0, l = channels; i < l; i++){
            const result = generator.generate();
            const bin = result.data;
            const maxValue = result.maxValue;
            for(let j = 0, l2 = bin.length; j < l2; j++){
                const value = bin[j] / maxValue;
                data[j * stride + i] = value;
            }
        }
        this.needsUpdate = true;
    }
}

});
parcelRegister("7Afqk", function(module, exports) {

$parcel$export(module.exports, "BlueNoiseGenerator", () => $5857dc03ab71e5c3$export$395052bf180baf1f);

var $3voRb = parcelRequire("3voRb");

var $dfd8t = parcelRequire("dfd8t");
class $5857dc03ab71e5c3$export$395052bf180baf1f {
    constructor(){
        this.random = Math.random;
        this.sigma = 1.5;
        this.size = 64;
        this.majorityPointsRatio = 0.1;
        this.samples = new (0, $dfd8t.BlueNoiseSamples)(1);
        this.savedSamples = new (0, $dfd8t.BlueNoiseSamples)(1);
    }
    generate() {
        // http://cv.ulichney.com/papers/1993-void-cluster.pdf
        const { samples: samples, savedSamples: savedSamples, sigma: sigma, majorityPointsRatio: majorityPointsRatio, size: size } = this;
        samples.resize(size);
        samples.setSigma(sigma);
        // 1. Randomly place the minority points.
        const pointCount = Math.floor(size * size * majorityPointsRatio);
        const initialSamples = samples.binaryPattern;
        (0, $3voRb.fillWithOnes)(initialSamples, pointCount);
        (0, $3voRb.shuffleArray)(initialSamples, this.random);
        for(let i = 0, l = initialSamples.length; i < l; i++)if (initialSamples[i] === 1) samples.addPointIndex(i);
        // 2. Remove minority point that is in densest cluster and place it in the largest void.
        while(true){
            const clusterIndex = samples.findCluster();
            samples.removePointIndex(clusterIndex);
            const voidIndex = samples.findVoid();
            if (clusterIndex === voidIndex) {
                samples.addPointIndex(clusterIndex);
                break;
            }
            samples.addPointIndex(voidIndex);
        }
        // 3. PHASE I: Assign a rank to each progressively less dense cluster point and put it
        // in the dither array.
        const ditherArray = new Uint32Array(size * size);
        savedSamples.copy(samples);
        let rank;
        rank = samples.count - 1;
        while(rank >= 0){
            const clusterIndex = samples.findCluster();
            samples.removePointIndex(clusterIndex);
            ditherArray[clusterIndex] = rank;
            rank--;
        }
        // 4. PHASE II: Do the same thing for the largest voids up to half of the total pixels using
        // the initial binary pattern.
        const totalSize = size * size;
        rank = savedSamples.count;
        while(rank < totalSize / 2){
            const voidIndex = savedSamples.findVoid();
            savedSamples.addPointIndex(voidIndex);
            ditherArray[voidIndex] = rank;
            rank++;
        }
        // 5. PHASE III: Invert the pattern and finish out by assigning a rank to the remaining
        // and iteratively removing them.
        savedSamples.invert();
        while(rank < totalSize){
            const clusterIndex = savedSamples.findCluster();
            savedSamples.removePointIndex(clusterIndex);
            ditherArray[clusterIndex] = rank;
            rank++;
        }
        return {
            data: ditherArray,
            maxValue: totalSize
        };
    }
}

});
parcelRegister("3voRb", function(module, exports) {

$parcel$export(module.exports, "shuffleArray", () => $28d78c69b5764593$export$7ac3a88d34a76e7);
$parcel$export(module.exports, "fillWithOnes", () => $28d78c69b5764593$export$50dc72eec73f3f5d);
function $28d78c69b5764593$export$7ac3a88d34a76e7(array, random = Math.random) {
    for(let i = array.length - 1; i > 0; i--){
        const replaceIndex = ~~((random() - 1e-6) * i);
        const tmp = array[i];
        array[i] = array[replaceIndex];
        array[replaceIndex] = tmp;
    }
}
function $28d78c69b5764593$export$50dc72eec73f3f5d(array, count) {
    array.fill(0);
    for(let i = 0; i < count; i++)array[i] = 1;
}

});

parcelRegister("dfd8t", function(module, exports) {

$parcel$export(module.exports, "BlueNoiseSamples", () => $9a46dd8a24c94e3f$export$ce82934b5dfddd2e);
class $9a46dd8a24c94e3f$export$ce82934b5dfddd2e {
    constructor(size){
        this.count = 0;
        this.size = -1;
        this.sigma = -1;
        this.radius = -1;
        this.lookupTable = null;
        this.score = null;
        this.binaryPattern = null;
        this.resize(size);
        this.setSigma(1.5);
    }
    findVoid() {
        const { score: score, binaryPattern: binaryPattern } = this;
        let currValue = Infinity;
        let currIndex = -1;
        for(let i = 0, l = binaryPattern.length; i < l; i++){
            if (binaryPattern[i] !== 0) continue;
            const pScore = score[i];
            if (pScore < currValue) {
                currValue = pScore;
                currIndex = i;
            }
        }
        return currIndex;
    }
    findCluster() {
        const { score: score, binaryPattern: binaryPattern } = this;
        let currValue = -Infinity;
        let currIndex = -1;
        for(let i = 0, l = binaryPattern.length; i < l; i++){
            if (binaryPattern[i] !== 1) continue;
            const pScore = score[i];
            if (pScore > currValue) {
                currValue = pScore;
                currIndex = i;
            }
        }
        return currIndex;
    }
    setSigma(sigma) {
        if (sigma === this.sigma) return;
        // generate a radius in which the score will be updated under the
        // assumption that e^-10 is insignificant enough to be the border at
        // which we drop off.
        const radius = ~~(Math.sqrt(20 * sigma ** 2) + 1);
        const lookupWidth = 2 * radius + 1;
        const lookupTable = new Float32Array(lookupWidth * lookupWidth);
        const sigma2 = sigma * sigma;
        for(let x = -radius; x <= radius; x++)for(let y = -radius; y <= radius; y++){
            const index = (radius + y) * lookupWidth + x + radius;
            const dist2 = x * x + y * y;
            lookupTable[index] = Math.E ** (-dist2 / (2 * sigma2));
        }
        this.lookupTable = lookupTable;
        this.sigma = sigma;
        this.radius = radius;
    }
    resize(size) {
        if (this.size !== size) {
            this.size = size;
            this.score = new Float32Array(size * size);
            this.binaryPattern = new Uint8Array(size * size);
        }
    }
    invert() {
        const { binaryPattern: binaryPattern, score: score, size: size } = this;
        score.fill(0);
        for(let i = 0, l = binaryPattern.length; i < l; i++)if (binaryPattern[i] === 0) {
            const y = ~~(i / size);
            const x = i - y * size;
            this.updateScore(x, y, 1);
            binaryPattern[i] = 1;
        } else binaryPattern[i] = 0;
    }
    updateScore(x, y, multiplier) {
        // TODO: Is there a way to keep track of the highest and lowest scores here to avoid have to search over
        // everything in the buffer?
        const { size: size, score: score, lookupTable: lookupTable } = this;
        // const sigma2 = sigma * sigma;
        // const radius = Math.floor( size / 2 );
        const radius = this.radius;
        const lookupWidth = 2 * radius + 1;
        for(let px = -radius; px <= radius; px++)for(let py = -radius; py <= radius; py++){
            // const dist2 = px * px + py * py;
            // const value = Math.E ** ( - dist2 / ( 2 * sigma2 ) );
            const lookupIndex = (radius + py) * lookupWidth + px + radius;
            const value = lookupTable[lookupIndex];
            let sx = x + px;
            sx = sx < 0 ? size + sx : sx % size;
            let sy = y + py;
            sy = sy < 0 ? size + sy : sy % size;
            const sindex = sy * size + sx;
            score[sindex] += multiplier * value;
        }
    }
    addPointIndex(index) {
        this.binaryPattern[index] = 1;
        const size = this.size;
        const y = ~~(index / size);
        const x = index - y * size;
        this.updateScore(x, y, 1);
        this.count++;
    }
    removePointIndex(index) {
        this.binaryPattern[index] = 0;
        const size = this.size;
        const y = ~~(index / size);
        const x = index - y * size;
        this.updateScore(x, y, -1);
        this.count--;
    }
    copy(source) {
        this.resize(source.size);
        this.score.set(source.score);
        this.binaryPattern.set(source.binaryPattern);
        this.setSigma(source.sigma);
        this.count = source.count;
    }
}

});



parcelRegister("sORjD", function(module, exports) {

$parcel$export(module.exports, "camera_struct", () => $056a1129e103f8a3$export$ff29bcb3325786f4);
const $056a1129e103f8a3$export$ff29bcb3325786f4 = /* glsl */ `

	struct PhysicalCamera {

		float focusDistance;
		float anamorphicRatio;
		float bokehSize;
		int apertureBlades;
		float apertureRotation;

	};

`;

});

parcelRegister("WBvYF", function(module, exports) {

$parcel$export(module.exports, "equirect_struct", () => $0b02848bbcd9659f$export$55a5ad677f09b429);
const $0b02848bbcd9659f$export$55a5ad677f09b429 = /* glsl */ `

	struct EquirectHdrInfo {

		sampler2D marginalWeights;
		sampler2D conditionalWeights;
		sampler2D map;

		float totalSum;

	};

`;

});

parcelRegister("1QwjS", function(module, exports) {

$parcel$export(module.exports, "lights_struct", () => $1583b7c3c4aba100$export$b8142914126932cc);
const $1583b7c3c4aba100$export$b8142914126932cc = /* glsl */ `

	#define RECT_AREA_LIGHT_TYPE 0
	#define CIRC_AREA_LIGHT_TYPE 1
	#define SPOT_LIGHT_TYPE 2
	#define DIR_LIGHT_TYPE 3
	#define POINT_LIGHT_TYPE 4

	struct LightsInfo {

		sampler2D tex;
		uint count;

	};

	struct Light {

		vec3 position;
		int type;

		vec3 color;
		float intensity;

		vec3 u;
		vec3 v;
		float area;

		// spot light fields
		float radius;
		float near;
		float decay;
		float distance;
		float coneCos;
		float penumbraCos;
		int iesProfile;

	};

	Light readLightInfo( sampler2D tex, uint index ) {

		uint i = index * 6u;

		vec4 s0 = texelFetch1D( tex, i + 0u );
		vec4 s1 = texelFetch1D( tex, i + 1u );
		vec4 s2 = texelFetch1D( tex, i + 2u );
		vec4 s3 = texelFetch1D( tex, i + 3u );

		Light l;
		l.position = s0.rgb;
		l.type = int( round( s0.a ) );

		l.color = s1.rgb;
		l.intensity = s1.a;

		l.u = s2.rgb;
		l.v = s3.rgb;
		l.area = s3.a;

		if ( l.type == SPOT_LIGHT_TYPE || l.type == POINT_LIGHT_TYPE ) {

			vec4 s4 = texelFetch1D( tex, i + 4u );
			vec4 s5 = texelFetch1D( tex, i + 5u );
			l.radius = s4.r;
			l.decay = s4.g;
			l.distance = s4.b;
			l.coneCos = s4.a;

			l.penumbraCos = s5.r;
			l.iesProfile = int( round( s5.g ) );

		} else {

			l.radius = 0.0;
			l.decay = 0.0;
			l.distance = 0.0;

			l.coneCos = 0.0;
			l.penumbraCos = 0.0;
			l.iesProfile = - 1;

		}

		return l;

	}

`;

});

parcelRegister("asLEI", function(module, exports) {

$parcel$export(module.exports, "surface_record_struct", () => $79e17c5d028db7ed$export$d11a3e67165e5cc8);
const $79e17c5d028db7ed$export$d11a3e67165e5cc8 = /* glsl */ `

	struct SurfaceRecord {

		// surface type
		bool volumeParticle;

		// geometry
		vec3 faceNormal;
		bool frontFace;
		vec3 normal;
		mat3 normalBasis;
		mat3 normalInvBasis;

		// cached properties
		float eta;
		float f0;

		// material
		float roughness;
		float filteredRoughness;
		float metalness;
		vec3 color;
		vec3 emission;

		// transmission
		float ior;
		float transmission;
		bool thinFilm;
		vec3 attenuationColor;
		float attenuationDistance;

		// clearcoat
		vec3 clearcoatNormal;
		mat3 clearcoatBasis;
		mat3 clearcoatInvBasis;
		float clearcoat;
		float clearcoatRoughness;
		float filteredClearcoatRoughness;

		// sheen
		float sheen;
		vec3 sheenColor;
		float sheenRoughness;

		// iridescence
		float iridescence;
		float iridescenceIor;
		float iridescenceThickness;

		// specular
		vec3 specularColor;
		float specularIntensity;
	};

	struct ScatterRecord {
		float specularPdf;
		float pdf;
		vec3 direction;
		vec3 color;
	};

`;

});

parcelRegister("6VF8W", function(module, exports) {

$parcel$export(module.exports, "equirect_functions", () => $50b7fb1d651b0127$export$8450b254896ea12);
const $50b7fb1d651b0127$export$8450b254896ea12 = /* glsl */ `

	// samples the the given environment map in the given direction
	vec3 sampleEquirectColor( sampler2D envMap, vec3 direction ) {

		return texture2D( envMap, equirectDirectionToUv( direction ) ).rgb;

	}

	// gets the pdf of the given direction to sample
	float equirectDirectionPdf( vec3 direction ) {

		vec2 uv = equirectDirectionToUv( direction );
		float theta = uv.y * PI;
		float sinTheta = sin( theta );
		if ( sinTheta == 0.0 ) {

			return 0.0;

		}

		return 1.0 / ( 2.0 * PI * PI * sinTheta );

	}

	// samples the color given env map with CDF and returns the pdf of the direction
	float sampleEquirect( vec3 direction, inout vec3 color ) {

		float totalSum = envMapInfo.totalSum;
		if ( totalSum == 0.0 ) {

			color = vec3( 0.0 );
			return 1.0;

		}

		vec2 uv = equirectDirectionToUv( direction );
		color = texture2D( envMapInfo.map, uv ).rgb;

		float lum = luminance( color );
		ivec2 resolution = textureSize( envMapInfo.map, 0 );
		float pdf = lum / totalSum;

		return float( resolution.x * resolution.y ) * pdf * equirectDirectionPdf( direction );

	}

	// samples a direction of the envmap with color and retrieves pdf
	float sampleEquirectProbability( vec2 r, inout vec3 color, inout vec3 direction ) {

		// sample env map cdf
		float v = texture2D( envMapInfo.marginalWeights, vec2( r.x, 0.0 ) ).x;
		float u = texture2D( envMapInfo.conditionalWeights, vec2( r.y, v ) ).x;
		vec2 uv = vec2( u, v );

		vec3 derivedDirection = equirectUvToDirection( uv );
		direction = derivedDirection;
		color = texture2D( envMapInfo.map, uv ).rgb;

		float totalSum = envMapInfo.totalSum;
		float lum = luminance( color );
		ivec2 resolution = textureSize( envMapInfo.map, 0 );
		float pdf = lum / totalSum;

		return float( resolution.x * resolution.y ) * pdf * equirectDirectionPdf( direction );

	}
`;

});

parcelRegister("232IN", function(module, exports) {

$parcel$export(module.exports, "light_sampling_functions", () => $17ddf9091b3b4093$export$a22775c3497c2ab8);
const $17ddf9091b3b4093$export$a22775c3497c2ab8 = /* glsl */ `

	float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {

		return smoothstep( coneCosine, penumbraCosine, angleCosine );

	}

	float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {

		// based upon Frostbite 3 Moving to Physically-based Rendering
		// page 32, equation 26: E[window1]
		// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), EPSILON );

		if ( cutoffDistance > 0.0 ) {

			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );

		}

		return distanceFalloff;

	}

	float getPhotometricAttenuation( sampler2DArray iesProfiles, int iesProfile, vec3 posToLight, vec3 lightDir, vec3 u, vec3 v ) {

		float cosTheta = dot( posToLight, lightDir );
		float angle = acos( cosTheta ) / PI;

		return texture2D( iesProfiles, vec3( angle, 0.0, iesProfile ) ).r;

	}

	struct LightRecord {

		float dist;
		vec3 direction;
		float pdf;
		vec3 emission;
		int type;

	};

	bool intersectLightAtIndex( sampler2D lights, vec3 rayOrigin, vec3 rayDirection, uint l, inout LightRecord lightRec ) {

		bool didHit = false;
		Light light = readLightInfo( lights, l );

		vec3 u = light.u;
		vec3 v = light.v;

		// check for backface
		vec3 normal = normalize( cross( u, v ) );
		if ( dot( normal, rayDirection ) > 0.0 ) {

			u *= 1.0 / dot( u, u );
			v *= 1.0 / dot( v, v );

			float dist;

			// MIS / light intersection is not supported for punctual lights.
			if(
				( light.type == RECT_AREA_LIGHT_TYPE && intersectsRectangle( light.position, normal, u, v, rayOrigin, rayDirection, dist ) ) ||
				( light.type == CIRC_AREA_LIGHT_TYPE && intersectsCircle( light.position, normal, u, v, rayOrigin, rayDirection, dist ) )
			) {

				float cosTheta = dot( rayDirection, normal );
				didHit = true;
				lightRec.dist = dist;
				lightRec.pdf = ( dist * dist ) / ( light.area * cosTheta );
				lightRec.emission = light.color * light.intensity;
				lightRec.direction = rayDirection;
				lightRec.type = light.type;

			}

		}

		return didHit;

	}

	LightRecord randomAreaLightSample( Light light, vec3 rayOrigin, vec2 ruv ) {

		vec3 randomPos;
		if( light.type == RECT_AREA_LIGHT_TYPE ) {

			// rectangular area light
			randomPos = light.position + light.u * ( ruv.x - 0.5 ) + light.v * ( ruv.y - 0.5 );

		} else if( light.type == CIRC_AREA_LIGHT_TYPE ) {

			// circular area light
			float r = 0.5 * sqrt( ruv.x );
			float theta = ruv.y * 2.0 * PI;
			float x = r * cos( theta );
			float y = r * sin( theta );

			randomPos = light.position + light.u * x + light.v * y;

		}

		vec3 toLight = randomPos - rayOrigin;
		float lightDistSq = dot( toLight, toLight );
		float dist = sqrt( lightDistSq );
		vec3 direction = toLight / dist;
		vec3 lightNormal = normalize( cross( light.u, light.v ) );

		LightRecord lightRec;
		lightRec.type = light.type;
		lightRec.emission = light.color * light.intensity;
		lightRec.dist = dist;
		lightRec.direction = direction;

		// TODO: the denominator is potentially zero
		lightRec.pdf = lightDistSq / ( light.area * dot( direction, lightNormal ) );

		return lightRec;

	}

	LightRecord randomSpotLightSample( Light light, sampler2DArray iesProfiles, vec3 rayOrigin, vec2 ruv ) {

		float radius = light.radius * sqrt( ruv.x );
		float theta = ruv.y * 2.0 * PI;
		float x = radius * cos( theta );
		float y = radius * sin( theta );

		vec3 u = light.u;
		vec3 v = light.v;
		vec3 normal = normalize( cross( u, v ) );

		float angle = acos( light.coneCos );
		float angleTan = tan( angle );
		float startDistance = light.radius / max( angleTan, EPSILON );

		vec3 randomPos = light.position - normal * startDistance + u * x + v * y;
		vec3 toLight = randomPos - rayOrigin;
		float lightDistSq = dot( toLight, toLight );
		float dist = sqrt( lightDistSq );

		vec3 direction = toLight / max( dist, EPSILON );
		float cosTheta = dot( direction, normal );

		float spotAttenuation = light.iesProfile != - 1 ?
			getPhotometricAttenuation( iesProfiles, light.iesProfile, direction, normal, u, v ) :
			getSpotAttenuation( light.coneCos, light.penumbraCos, cosTheta );

		float distanceAttenuation = getDistanceAttenuation( dist, light.distance, light.decay );
		LightRecord lightRec;
		lightRec.type = light.type;
		lightRec.dist = dist;
		lightRec.direction = direction;
		lightRec.emission = light.color * light.intensity * distanceAttenuation * spotAttenuation;
		lightRec.pdf = 1.0;

		return lightRec;

	}

	LightRecord randomLightSample( sampler2D lights, sampler2DArray iesProfiles, uint lightCount, vec3 rayOrigin, vec3 ruv ) {

		LightRecord result;

		// pick a random light
		uint l = uint( ruv.x * float( lightCount ) );
		Light light = readLightInfo( lights, l );

		if ( light.type == SPOT_LIGHT_TYPE ) {

			result = randomSpotLightSample( light, iesProfiles, rayOrigin, ruv.yz );

		} else if ( light.type == POINT_LIGHT_TYPE ) {

			vec3 lightRay = light.u - rayOrigin;
			float lightDist = length( lightRay );
			float cutoffDistance = light.distance;
			float distanceFalloff = 1.0 / max( pow( lightDist, light.decay ), 0.01 );
			if ( cutoffDistance > 0.0 ) {

				distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDist / cutoffDistance ) ) );

			}

			LightRecord rec;
			rec.direction = normalize( lightRay );
			rec.dist = length( lightRay );
			rec.pdf = 1.0;
			rec.emission = light.color * light.intensity * distanceFalloff;
			rec.type = light.type;
			result = rec;

		} else if ( light.type == DIR_LIGHT_TYPE ) {

			LightRecord rec;
			rec.dist = 1e10;
			rec.direction = light.u;
			rec.pdf = 1.0;
			rec.emission = light.color * light.intensity;
			rec.type = light.type;

			result = rec;

		} else {

			// sample the light
			result = randomAreaLightSample( light, rayOrigin, ruv.yz );

		}

		return result;

	}

`;

});

parcelRegister("8KxWl", function(module, exports) {

$parcel$export(module.exports, "fresnel_functions", () => $65ecf25fdf796e21$export$2f3e20d8a82fe5e3);
const $65ecf25fdf796e21$export$2f3e20d8a82fe5e3 = /* glsl */ `

	bool totalInternalReflection( float cosTheta, float eta ) {

		float sinTheta = sqrt( 1.0 - cosTheta * cosTheta );
		return eta * sinTheta > 1.0;

	}

	// https://google.github.io/filament/Filament.md.html#materialsystem/diffusebrdf
	float schlickFresnel( float cosine, float f0 ) {

		return f0 + ( 1.0 - f0 ) * pow( 1.0 - cosine, 5.0 );

	}

	vec3 schlickFresnel( float cosine, vec3 f0 ) {

		return f0 + ( 1.0 - f0 ) * pow( 1.0 - cosine, 5.0 );

	}

	vec3 schlickFresnel( float cosine, vec3 f0, vec3 f90 ) {

		return f0 + ( f90 - f0 ) * pow( 1.0 - cosine, 5.0 );

	}

	float dielectricFresnel( float cosThetaI, float eta ) {

		// https://schuttejoe.github.io/post/disneybsdf/
		float ni = eta;
		float nt = 1.0;

		// Check for total internal reflection
		float sinThetaISq = 1.0f - cosThetaI * cosThetaI;
		float sinThetaTSq = eta * eta * sinThetaISq;
		if( sinThetaTSq >= 1.0 ) {

			return 1.0;

		}

		float sinThetaT = sqrt( sinThetaTSq );

		float cosThetaT = sqrt( max( 0.0, 1.0f - sinThetaT * sinThetaT ) );
		float rParallel = ( ( nt * cosThetaI ) - ( ni * cosThetaT ) ) / ( ( nt * cosThetaI ) + ( ni * cosThetaT ) );
		float rPerpendicular = ( ( ni * cosThetaI ) - ( nt * cosThetaT ) ) / ( ( ni * cosThetaI ) + ( nt * cosThetaT ) );
		return ( rParallel * rParallel + rPerpendicular * rPerpendicular ) / 2.0;

	}

	// https://raytracing.github.io/books/RayTracingInOneWeekend.html#dielectrics/schlickapproximation
	float iorRatioToF0( float eta ) {

		return pow( ( 1.0 - eta ) / ( 1.0 + eta ), 2.0 );

	}

	vec3 evaluateFresnel( float cosTheta, float eta, vec3 f0, vec3 f90 ) {

		if ( totalInternalReflection( cosTheta, eta ) ) {

			return f90;

		}

		return schlickFresnel( cosTheta, f0, f90 );

	}

	// TODO: disney fresnel was removed and replaced with this fresnel function to better align with
	// the glTF but is causing blown out pixels. Should be revisited
	// float evaluateFresnelWeight( float cosTheta, float eta, float f0 ) {

	// 	if ( totalInternalReflection( cosTheta, eta ) ) {

	// 		return 1.0;

	// 	}

	// 	return schlickFresnel( cosTheta, f0 );

	// }

	// https://schuttejoe.github.io/post/disneybsdf/
	float disneyFresnel( vec3 wo, vec3 wi, vec3 wh, float f0, float eta, float metalness ) {

		float dotHV = dot( wo, wh );
		if ( totalInternalReflection( dotHV, eta ) ) {

			return 1.0;

		}

		float dotHL = dot( wi, wh );
		float dielectricFresnel = dielectricFresnel( abs( dotHV ), eta );
		float metallicFresnel = schlickFresnel( dotHL, f0 );

		return mix( dielectricFresnel, metallicFresnel, metalness );

	}

`;

});

parcelRegister("d9skn", function(module, exports) {

$parcel$export(module.exports, "shape_intersection_functions", () => $993216e4b4262820$export$c580e1bca0d1e835);
const $993216e4b4262820$export$c580e1bca0d1e835 = /* glsl */ `

	// Finds the point where the ray intersects the plane defined by u and v and checks if this point
	// falls in the bounds of the rectangle on that same plane.
	// Plane intersection: https://lousodrome.net/blog/light/2020/07/03/intersection-of-a-ray-and-a-plane/
	bool intersectsRectangle( vec3 center, vec3 normal, vec3 u, vec3 v, vec3 rayOrigin, vec3 rayDirection, inout float dist ) {

		float t = dot( center - rayOrigin, normal ) / dot( rayDirection, normal );

		if ( t > EPSILON ) {

			vec3 p = rayOrigin + rayDirection * t;
			vec3 vi = p - center;

			// check if p falls inside the rectangle
			float a1 = dot( u, vi );
			if ( abs( a1 ) <= 0.5 ) {

				float a2 = dot( v, vi );
				if ( abs( a2 ) <= 0.5 ) {

					dist = t;
					return true;

				}

			}

		}

		return false;

	}

	// Finds the point where the ray intersects the plane defined by u and v and checks if this point
	// falls in the bounds of the circle on that same plane. See above URL for a description of the plane intersection algorithm.
	bool intersectsCircle( vec3 position, vec3 normal, vec3 u, vec3 v, vec3 rayOrigin, vec3 rayDirection, inout float dist ) {

		float t = dot( position - rayOrigin, normal ) / dot( rayDirection, normal );

		if ( t > EPSILON ) {

			vec3 hit = rayOrigin + rayDirection * t;
			vec3 vi = hit - position;

			float a1 = dot( u, vi );
			float a2 = dot( v, vi );

			if( length( vec2( a1, a2 ) ) <= 0.5 ) {

				dist = t;
				return true;

			}

		}

		return false;

	}

`;

});

parcelRegister("jpfro", function(module, exports) {

$parcel$export(module.exports, "texture_sample_functions", () => $e20c545bebebbdde$export$4c62bb41ef52ef46);
const $e20c545bebebbdde$export$4c62bb41ef52ef46 = /*glsl */ `

	// add texel fetch functions for texture arrays
	vec4 texelFetch1D( sampler2DArray tex, int layer, uint index ) {

		uint width = uint( textureSize( tex, 0 ).x );
		uvec2 uv;
		uv.x = index % width;
		uv.y = index / width;

		return texelFetch( tex, ivec3( uv, layer ), 0 );

	}

	vec4 textureSampleBarycoord( sampler2DArray tex, int layer, vec3 barycoord, uvec3 faceIndices ) {

		return
			barycoord.x * texelFetch1D( tex, layer, faceIndices.x ) +
			barycoord.y * texelFetch1D( tex, layer, faceIndices.y ) +
			barycoord.z * texelFetch1D( tex, layer, faceIndices.z );

	}

`;

});

parcelRegister("gCBx4", function(module, exports) {

$parcel$export(module.exports, "stratified_functions", () => $c19d4f19383277fc$export$a7b9b03dc39b0c39);
const $c19d4f19383277fc$export$a7b9b03dc39b0c39 = /* glsl */ `

	uniform sampler2D stratifiedTexture;
	uniform sampler2D stratifiedOffsetTexture;

	uint sobolPixelIndex = 0u;
	uint sobolPathIndex = 0u;
	uint sobolBounceIndex = 0u;
	vec4 pixelSeed = vec4( 0 );

	vec4 rand4( int v ) {

		ivec2 uv = ivec2( v, sobolBounceIndex );
		vec4 stratifiedSample = texelFetch( stratifiedTexture, uv, 0 );
		return fract( stratifiedSample + pixelSeed.r ); // blue noise + stratified samples

	}

	vec3 rand3( int v ) {

		return rand4( v ).xyz;

	}

	vec2 rand2( int v ) {

		return rand4( v ).xy;

	}

	float rand( int v ) {

		return rand4( v ).x;

	}

	void rng_initialize( vec2 screenCoord, int frame ) {

		// tile the small noise texture across the entire screen
		ivec2 noiseSize = ivec2( textureSize( stratifiedOffsetTexture, 0 ) );
		ivec2 pixel = ivec2( screenCoord.xy ) % noiseSize;
		vec2 pixelWidth = 1.0 / vec2( noiseSize );
		vec2 uv = vec2( pixel ) * pixelWidth + pixelWidth * 0.5;

		// note that using "texelFetch" here seems to break Android for some reason
		pixelSeed = texture( stratifiedOffsetTexture, uv );

	}

`;

});

parcelRegister("6voD8", function(module, exports) {

$parcel$export(module.exports, "bsdf_functions", () => $4bc8be5fc03f5cd3$export$c0d7886d8c99f58c);
/*
wi     : incident vector or light vector (pointing toward the light)
wo     : outgoing vector or view vector (pointing towards the camera)
wh     : computed half vector from wo and wi
Eval   : Get the color and pdf for a direction
Sample : Get the direction, color, and pdf for a sample
eta    : Greek character used to denote the "ratio of ior"
f0     : Amount of light reflected when looking at a surface head on - "fresnel 0"
f90    : Amount of light reflected at grazing angles
*/ const $4bc8be5fc03f5cd3$export$c0d7886d8c99f58c = /* glsl */ `

	// diffuse
	float diffuseEval( vec3 wo, vec3 wi, vec3 wh, SurfaceRecord surf, inout vec3 color ) {

		// https://schuttejoe.github.io/post/disneybsdf/
		float fl = schlickFresnel( wi.z, 0.0 );
		float fv = schlickFresnel( wo.z, 0.0 );

		float metalFactor = ( 1.0 - surf.metalness );
		float transFactor = ( 1.0 - surf.transmission );
		float rr = 0.5 + 2.0 * surf.roughness * fl * fl;
		float retro = rr * ( fl + fv + fl * fv * ( rr - 1.0f ) );
		float lambert = ( 1.0f - 0.5f * fl ) * ( 1.0f - 0.5f * fv );

		// TODO: subsurface approx?

		// float F = evaluateFresnelWeight( dot( wo, wh ), surf.eta, surf.f0 );
		float F = disneyFresnel( wo, wi, wh, surf.f0, surf.eta, surf.metalness );
		color = ( 1.0 - F ) * transFactor * metalFactor * wi.z * surf.color * ( retro + lambert ) / PI;

		return wi.z / PI;

	}

	vec3 diffuseDirection( vec3 wo, SurfaceRecord surf ) {

		vec3 lightDirection = sampleSphere( rand2( 11 ) );
		lightDirection.z += 1.0;
		lightDirection = normalize( lightDirection );

		return lightDirection;

	}

	// specular
	float specularEval( vec3 wo, vec3 wi, vec3 wh, SurfaceRecord surf, inout vec3 color ) {

		// if roughness is set to 0 then D === NaN which results in black pixels
		float metalness = surf.metalness;
		float roughness = surf.filteredRoughness;

		float eta = surf.eta;
		float f0 = surf.f0;

		vec3 f0Color = mix( f0 * surf.specularColor * surf.specularIntensity, surf.color, surf.metalness );
		vec3 f90Color = vec3( mix( surf.specularIntensity, 1.0, surf.metalness ) );
		vec3 F = evaluateFresnel( dot( wo, wh ), eta, f0Color, f90Color );

		vec3 iridescenceF = evalIridescence( 1.0, surf.iridescenceIor, dot( wi, wh ), surf.iridescenceThickness, f0Color );
		F = mix( F, iridescenceF,  surf.iridescence );

		// PDF
		// See 14.1.1 Microfacet BxDFs in https://www.pbr-book.org/
		float incidentTheta = acos( wo.z );
		float G = ggxShadowMaskG2( wi, wo, roughness );
		float D = ggxDistribution( wh, roughness );
		float G1 = ggxShadowMaskG1( incidentTheta, roughness );
		float ggxPdf = D * G1 * max( 0.0, abs( dot( wo, wh ) ) ) / abs ( wo.z );

		color = wi.z * F * G * D / ( 4.0 * abs( wi.z * wo.z ) );
		return ggxPdf / ( 4.0 * dot( wo, wh ) );

	}

	vec3 specularDirection( vec3 wo, SurfaceRecord surf ) {

		// sample ggx vndf distribution which gives a new normal
		float roughness = surf.filteredRoughness;
		vec3 halfVector = ggxDirection(
			wo,
			vec2( roughness ),
			rand2( 12 )
		);

		// apply to new ray by reflecting off the new normal
		return - reflect( wo, halfVector );

	}


	// transmission
	/*
	float transmissionEval( vec3 wo, vec3 wi, vec3 wh, SurfaceRecord surf, inout vec3 color ) {

		// See section 4.2 in https://www.cs.cornell.edu/~srm/publications/EGSR07-btdf.pdf

		float filteredRoughness = surf.filteredRoughness;
		float eta = surf.eta;
		bool frontFace = surf.frontFace;
		bool thinFilm = surf.thinFilm;

		color = surf.transmission * surf.color;

		float denom = pow( eta * dot( wi, wh ) + dot( wo, wh ), 2.0 );
		return ggxPDF( wo, wh, filteredRoughness ) / denom;

	}

	vec3 transmissionDirection( vec3 wo, SurfaceRecord surf ) {

		float filteredRoughness = surf.filteredRoughness;
		float eta = surf.eta;
		bool frontFace = surf.frontFace;

		// sample ggx vndf distribution which gives a new normal
		vec3 halfVector = ggxDirection(
			wo,
			vec2( filteredRoughness ),
			rand2( 13 )
		);

		vec3 lightDirection = refract( normalize( - wo ), halfVector, eta );
		if ( surf.thinFilm ) {

			lightDirection = - refract( normalize( - lightDirection ), - vec3( 0.0, 0.0, 1.0 ), 1.0 / eta );

		}

		return normalize( lightDirection );

	}
	*/

	// TODO: This is just using a basic cosine-weighted specular distribution with an
	// incorrect PDF value at the moment. Update it to correctly use a GGX distribution
	float transmissionEval( vec3 wo, vec3 wi, vec3 wh, SurfaceRecord surf, inout vec3 color ) {

		color = surf.transmission * surf.color;

		// PDF
		// float F = evaluateFresnelWeight( dot( wo, wh ), surf.eta, surf.f0 );
		// float F = disneyFresnel( wo, wi, wh, surf.f0, surf.eta, surf.metalness );
		// if ( F >= 1.0 ) {

		// 	return 0.0;

		// }

		// return 1.0 / ( 1.0 - F );

		// reverted to previous to transmission. The above was causing black pixels
		float eta = surf.eta;
		float f0 = surf.f0;
		float cosTheta = min( wo.z, 1.0 );
		float sinTheta = sqrt( 1.0 - cosTheta * cosTheta );
		float reflectance = schlickFresnel( cosTheta, f0 );
		bool cannotRefract = eta * sinTheta > 1.0;
		if ( cannotRefract ) {

			return 0.0;

		}

		return 1.0 / ( 1.0 - reflectance );

	}

	vec3 transmissionDirection( vec3 wo, SurfaceRecord surf ) {

		float roughness = surf.filteredRoughness;
		float eta = surf.eta;
		vec3 halfVector = normalize( vec3( 0.0, 0.0, 1.0 ) + sampleSphere( rand2( 13 ) ) * roughness );
		vec3 lightDirection = refract( normalize( - wo ), halfVector, eta );

		if ( surf.thinFilm ) {

			lightDirection = - refract( normalize( - lightDirection ), - vec3( 0.0, 0.0, 1.0 ), 1.0 / eta );

		}
		return normalize( lightDirection );

	}

	// clearcoat
	float clearcoatEval( vec3 wo, vec3 wi, vec3 wh, SurfaceRecord surf, inout vec3 color ) {

		float ior = 1.5;
		float f0 = iorRatioToF0( ior );
		bool frontFace = surf.frontFace;
		float roughness = surf.filteredClearcoatRoughness;

		float eta = frontFace ? 1.0 / ior : ior;
		float G = ggxShadowMaskG2( wi, wo, roughness );
		float D = ggxDistribution( wh, roughness );
		float F = schlickFresnel( dot( wi, wh ), f0 );

		float fClearcoat = F * D * G / ( 4.0 * abs( wi.z * wo.z ) );
		color = color * ( 1.0 - surf.clearcoat * F ) + fClearcoat * surf.clearcoat * wi.z;

		// PDF
		// See equation (27) in http://jcgt.org/published/0003/02/03/
		return ggxPDF( wo, wh, roughness ) / ( 4.0 * dot( wi, wh ) );

	}

	vec3 clearcoatDirection( vec3 wo, SurfaceRecord surf ) {

		// sample ggx vndf distribution which gives a new normal
		float roughness = surf.filteredClearcoatRoughness;
		vec3 halfVector = ggxDirection(
			wo,
			vec2( roughness ),
			rand2( 14 )
		);

		// apply to new ray by reflecting off the new normal
		return - reflect( wo, halfVector );

	}

	// sheen
	vec3 sheenColor( vec3 wo, vec3 wi, vec3 wh, SurfaceRecord surf ) {

		float cosThetaO = saturateCos( wo.z );
		float cosThetaI = saturateCos( wi.z );
		float cosThetaH = wh.z;

		float D = velvetD( cosThetaH, surf.sheenRoughness );
		float G = velvetG( cosThetaO, cosThetaI, surf.sheenRoughness );

		// See equation (1) in http://www.aconty.com/pdf/s2017_pbs_imageworks_sheen.pdf
		vec3 color = surf.sheenColor;
		color *= D * G / ( 4.0 * abs( cosThetaO * cosThetaI ) );
		color *= wi.z;

		return color;

	}

	// bsdf
	void getLobeWeights(
		vec3 wo, vec3 wi, vec3 wh, vec3 clearcoatWo, SurfaceRecord surf,
		inout float diffuseWeight, inout float specularWeight, inout float transmissionWeight, inout float clearcoatWeight
	) {

		float metalness = surf.metalness;
		float transmission = surf.transmission;
		// float fEstimate = evaluateFresnelWeight( dot( wo, wh ), surf.eta, surf.f0 );
		float fEstimate = disneyFresnel( wo, wi, wh, surf.f0, surf.eta, surf.metalness );

		float transSpecularProb = mix( max( 0.25, fEstimate ), 1.0, metalness );
		float diffSpecularProb = 0.5 + 0.5 * metalness;

		diffuseWeight = ( 1.0 - transmission ) * ( 1.0 - diffSpecularProb );
		specularWeight = transmission * transSpecularProb + ( 1.0 - transmission ) * diffSpecularProb;
		transmissionWeight = transmission * ( 1.0 - transSpecularProb );
		clearcoatWeight = surf.clearcoat * schlickFresnel( clearcoatWo.z, 0.04 );

		float totalWeight = diffuseWeight + specularWeight + transmissionWeight + clearcoatWeight;
		diffuseWeight /= totalWeight;
		specularWeight /= totalWeight;
		transmissionWeight /= totalWeight;
		clearcoatWeight /= totalWeight;
	}

	float bsdfEval(
		vec3 wo, vec3 clearcoatWo, vec3 wi, vec3 clearcoatWi, SurfaceRecord surf,
		float diffuseWeight, float specularWeight, float transmissionWeight, float clearcoatWeight, inout float specularPdf, inout vec3 color
	) {

		float metalness = surf.metalness;
		float transmission = surf.transmission;

		float spdf = 0.0;
		float dpdf = 0.0;
		float tpdf = 0.0;
		float cpdf = 0.0;
		color = vec3( 0.0 );

		vec3 halfVector = getHalfVector( wi, wo, surf.eta );

		// diffuse
		if ( diffuseWeight > 0.0 && wi.z > 0.0 ) {

			dpdf = diffuseEval( wo, wi, halfVector, surf, color );
			color *= 1.0 - surf.transmission;

		}

		// ggx specular
		if ( specularWeight > 0.0 && wi.z > 0.0 ) {

			vec3 outColor;
			spdf = specularEval( wo, wi, getHalfVector( wi, wo ), surf, outColor );
			color += outColor;

		}

		// transmission
		if ( transmissionWeight > 0.0 && wi.z < 0.0 ) {

			tpdf = transmissionEval( wo, wi, halfVector, surf, color );

		}

		// sheen
		color *= mix( 1.0, sheenAlbedoScaling( wo, wi, surf ), surf.sheen );
		color += sheenColor( wo, wi, halfVector, surf ) * surf.sheen;

		// clearcoat
		if ( clearcoatWi.z >= 0.0 && clearcoatWeight > 0.0 ) {

			vec3 clearcoatHalfVector = getHalfVector( clearcoatWo, clearcoatWi );
			cpdf = clearcoatEval( clearcoatWo, clearcoatWi, clearcoatHalfVector, surf, color );

		}

		float pdf =
			dpdf * diffuseWeight
			+ spdf * specularWeight
			+ tpdf * transmissionWeight
			+ cpdf * clearcoatWeight;

		// retrieve specular rays for the shadows flag
		specularPdf = spdf * specularWeight + cpdf * clearcoatWeight;

		return pdf;

	}

	float bsdfResult( vec3 worldWo, vec3 worldWi, SurfaceRecord surf, inout vec3 color ) {

		if ( surf.volumeParticle ) {

			color = surf.color / ( 4.0 * PI );
			return 1.0 / ( 4.0 * PI );

		}

		vec3 wo = normalize( surf.normalInvBasis * worldWo );
		vec3 wi = normalize( surf.normalInvBasis * worldWi );

		vec3 clearcoatWo = normalize( surf.clearcoatInvBasis * worldWo );
		vec3 clearcoatWi = normalize( surf.clearcoatInvBasis * worldWi );

		vec3 wh = getHalfVector( wo, wi, surf.eta );
		float diffuseWeight;
		float specularWeight;
		float transmissionWeight;
		float clearcoatWeight;
		getLobeWeights( wo, wi, wh, clearcoatWo, surf, diffuseWeight, specularWeight, transmissionWeight, clearcoatWeight );

		float specularPdf;
		return bsdfEval( wo, clearcoatWo, wi, clearcoatWi, surf, diffuseWeight, specularWeight, transmissionWeight, clearcoatWeight, specularPdf, color );

	}

	ScatterRecord bsdfSample( vec3 worldWo, SurfaceRecord surf ) {

		if ( surf.volumeParticle ) {

			ScatterRecord sampleRec;
			sampleRec.specularPdf = 0.0;
			sampleRec.pdf = 1.0 / ( 4.0 * PI );
			sampleRec.direction = sampleSphere( rand2( 16 ) );
			sampleRec.color = surf.color / ( 4.0 * PI );
			return sampleRec;

		}

		vec3 wo = normalize( surf.normalInvBasis * worldWo );
		vec3 clearcoatWo = normalize( surf.clearcoatInvBasis * worldWo );
		mat3 normalBasis = surf.normalBasis;
		mat3 invBasis = surf.normalInvBasis;
		mat3 clearcoatNormalBasis = surf.clearcoatBasis;
		mat3 clearcoatInvBasis = surf.clearcoatInvBasis;

		float diffuseWeight;
		float specularWeight;
		float transmissionWeight;
		float clearcoatWeight;
		// using normal and basically-reflected ray since we don't have proper half vector here
		getLobeWeights( wo, wo, vec3( 0, 0, 1 ), clearcoatWo, surf, diffuseWeight, specularWeight, transmissionWeight, clearcoatWeight );

		float pdf[4];
		pdf[0] = diffuseWeight;
		pdf[1] = specularWeight;
		pdf[2] = transmissionWeight;
		pdf[3] = clearcoatWeight;

		float cdf[4];
		cdf[0] = pdf[0];
		cdf[1] = pdf[1] + cdf[0];
		cdf[2] = pdf[2] + cdf[1];
		cdf[3] = pdf[3] + cdf[2];

		if( cdf[3] != 0.0 ) {

			float invMaxCdf = 1.0 / cdf[3];
			cdf[0] *= invMaxCdf;
			cdf[1] *= invMaxCdf;
			cdf[2] *= invMaxCdf;
			cdf[3] *= invMaxCdf;

		} else {

			cdf[0] = 1.0;
			cdf[1] = 0.0;
			cdf[2] = 0.0;
			cdf[3] = 0.0;

		}

		vec3 wi;
		vec3 clearcoatWi;

		float r = rand( 15 );
		if ( r <= cdf[0] ) { // diffuse

			wi = diffuseDirection( wo, surf );
			clearcoatWi = normalize( clearcoatInvBasis * normalize( normalBasis * wi ) );

		} else if ( r <= cdf[1] ) { // specular

			wi = specularDirection( wo, surf );
			clearcoatWi = normalize( clearcoatInvBasis * normalize( normalBasis * wi ) );

		} else if ( r <= cdf[2] ) { // transmission / refraction

			wi = transmissionDirection( wo, surf );
			clearcoatWi = normalize( clearcoatInvBasis * normalize( normalBasis * wi ) );

		} else if ( r <= cdf[3] ) { // clearcoat

			clearcoatWi = clearcoatDirection( clearcoatWo, surf );
			wi = normalize( invBasis * normalize( clearcoatNormalBasis * clearcoatWi ) );

		}

		ScatterRecord result;
		result.pdf = bsdfEval( wo, clearcoatWo, wi, clearcoatWi, surf, diffuseWeight, specularWeight, transmissionWeight, clearcoatWeight, result.specularPdf, result.color );
		result.direction = normalize( surf.normalBasis * wi );

		return result;

	}

`;

});

parcelRegister("4GDCw", function(module, exports) {

$parcel$export(module.exports, "fog_functions", () => $3699d1726d2f89b6$export$7e0eb49b04f8be76);
const $3699d1726d2f89b6$export$7e0eb49b04f8be76 = /* glsl */ `

	// returns the hit distance given the material density
	float intersectFogVolume( Material material, float u ) {

		// https://raytracing.github.io/books/RayTracingTheNextWeek.html#volumes/constantdensitymediums
		return material.opacity == 0.0 ? INFINITY : ( - 1.0 / material.opacity ) * log( u );

	}

	ScatterRecord sampleFogVolume( SurfaceRecord surf, vec2 uv ) {

		ScatterRecord sampleRec;
		sampleRec.specularPdf = 0.0;
		sampleRec.pdf = 1.0 / ( 2.0 * PI );
		sampleRec.direction = sampleSphere( uv );
		sampleRec.color = surf.color;
		return sampleRec;

	}

`;

});

parcelRegister("9kAYu", function(module, exports) {

$parcel$export(module.exports, "iridescence_functions", () => $6cb2a9b144b85589$export$c5fa12fdf656cb44);
const $6cb2a9b144b85589$export$c5fa12fdf656cb44 = /* glsl */ `

	// XYZ to sRGB color space
	const mat3 XYZ_TO_REC709 = mat3(
		3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);

	vec3 fresnel0ToIor( vec3 fresnel0 ) {

		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );

	}

	// Conversion FO/IOR
	vec3 iorToFresnel0( vec3 transmittedIor, float incidentIor ) {

		return square( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );

	}

	// ior is a value between 1.0 and 3.0. 1.0 is air interface
	float iorToFresnel0( float transmittedIor, float incidentIor ) {

		return square( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ) );

	}

	// Fresnel equations for dielectric/dielectric interfaces. See https://belcour.github.io/blog/research/2017/05/01/brdf-thin-film.html
	vec3 evalSensitivity( float OPD, vec3 shift ) {

		float phase = 2.0 * PI * OPD * 1.0e-9;

		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );

		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - square( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * square( phase ) );
		xyz /= 1.0685e-7;

		vec3 srgb = XYZ_TO_REC709 * xyz;
		return srgb;

	}

	// See Section 4. Analytic Spectral Integration, A Practical Extension to Microfacet Theory for the Modeling of Varying Iridescence, https://hal.archives-ouvertes.fr/hal-01518344/document
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {

		vec3 I;

		// Force iridescenceIor -> outsideIOR when thinFilmThickness -> 0.0
		float iridescenceIor = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );

		// Evaluate the cosTheta on the base layer (Snell law)
		float sinTheta2Sq = square( outsideIOR / iridescenceIor ) * ( 1.0 - square( cosTheta1 ) );

		// Handle TIR:
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {

			return vec3( 1.0 );

		}

		float cosTheta2 = sqrt( cosTheta2Sq );

		// First interface
		float R0 = iorToFresnel0( iridescenceIor, outsideIOR );
		float R12 = schlickFresnel( cosTheta1, R0 );
		float R21 = R12;
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIor < outsideIOR ) {

			phi12 = PI;

		}

		float phi21 = PI - phi12;

		// Second interface
		vec3 baseIOR = fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) ); // guard against 1.0
		vec3 R1 = iorToFresnel0( baseIOR, iridescenceIor );
		vec3 R23 = schlickFresnel( cosTheta2, R1 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[0] < iridescenceIor ) {

			phi23[ 0 ] = PI;

		}

		if ( baseIOR[1] < iridescenceIor ) {

			phi23[ 1 ] = PI;

		}

		if ( baseIOR[2] < iridescenceIor ) {

			phi23[ 2 ] = PI;

		}

		// Phase shift
		float OPD = 2.0 * iridescenceIor * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;

		// Compound terms
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = square( T121 ) * R23 / ( vec3( 1.0 ) - R123 );

		// Reflectance term for m = 0 (DC term amplitude)
		vec3 C0 = R12 + Rs;
		I = C0;

		// Reflectance term for m > 0 (pairs of diracs)
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {

			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;

		}

		// Since out of gamut colors might be produced, negative color values are clamped to 0.
		return max( I, vec3( 0.0 ) );

	}

`;

});

parcelRegister("5SszG", function(module, exports) {

$parcel$export(module.exports, "sheen_functions", () => $44782939f1da8c08$export$41b398d23411fca);
const $44782939f1da8c08$export$41b398d23411fca = /* glsl */ `

	// See equation (2) in http://www.aconty.com/pdf/s2017_pbs_imageworks_sheen.pdf
	float velvetD( float cosThetaH, float roughness ) {

		float alpha = max( roughness, 0.07 );
		alpha = alpha * alpha;

		float invAlpha = 1.0 / alpha;

		float sqrCosThetaH = cosThetaH * cosThetaH;
		float sinThetaH = max( 1.0 - sqrCosThetaH, 0.001 );

		return ( 2.0 + invAlpha ) * pow( sinThetaH, 0.5 * invAlpha ) / ( 2.0 * PI );

	}

	float velvetParamsInterpolate( int i, float oneMinusAlphaSquared ) {

		const float p0[5] = float[5]( 25.3245, 3.32435, 0.16801, -1.27393, -4.85967 );
		const float p1[5] = float[5]( 21.5473, 3.82987, 0.19823, -1.97760, -4.32054 );

		return mix( p1[i], p0[i], oneMinusAlphaSquared );

	}

	float velvetL( float x, float alpha ) {

		float oneMinusAlpha = 1.0 - alpha;
		float oneMinusAlphaSquared = oneMinusAlpha * oneMinusAlpha;

		float a = velvetParamsInterpolate( 0, oneMinusAlphaSquared );
		float b = velvetParamsInterpolate( 1, oneMinusAlphaSquared );
		float c = velvetParamsInterpolate( 2, oneMinusAlphaSquared );
		float d = velvetParamsInterpolate( 3, oneMinusAlphaSquared );
		float e = velvetParamsInterpolate( 4, oneMinusAlphaSquared );

		return a / ( 1.0 + b * pow( abs( x ), c ) ) + d * x + e;

	}

	// See equation (3) in http://www.aconty.com/pdf/s2017_pbs_imageworks_sheen.pdf
	float velvetLambda( float cosTheta, float alpha ) {

		return abs( cosTheta ) < 0.5 ? exp( velvetL( cosTheta, alpha ) ) : exp( 2.0 * velvetL( 0.5, alpha ) - velvetL( 1.0 - cosTheta, alpha ) );

	}

	// See Section 3, Shadowing Term, in http://www.aconty.com/pdf/s2017_pbs_imageworks_sheen.pdf
	float velvetG( float cosThetaO, float cosThetaI, float roughness ) {

		float alpha = max( roughness, 0.07 );
		alpha = alpha * alpha;

		return 1.0 / ( 1.0 + velvetLambda( cosThetaO, alpha ) + velvetLambda( cosThetaI, alpha ) );

	}

	float directionalAlbedoSheen( float cosTheta, float alpha ) {

		cosTheta = saturate( cosTheta );

		float c = 1.0 - cosTheta;
		float c3 = c * c * c;

		return 0.65584461 * c3 + 1.0 / ( 4.16526551 + exp( -7.97291361 * sqrt( alpha ) + 6.33516894 ) );

	}

	float sheenAlbedoScaling( vec3 wo, vec3 wi, SurfaceRecord surf ) {

		float alpha = max( surf.sheenRoughness, 0.07 );
		alpha = alpha * alpha;

		float maxSheenColor = max( max( surf.sheenColor.r, surf.sheenColor.g ), surf.sheenColor.b );

		float eWo = directionalAlbedoSheen( saturateCos( wo.z ), alpha );
		float eWi = directionalAlbedoSheen( saturateCos( wi.z ), alpha );

		return min( 1.0 - maxSheenColor * eWo, 1.0 - maxSheenColor * eWi );

	}

	// See Section 5, Layering, in http://www.aconty.com/pdf/s2017_pbs_imageworks_sheen.pdf
	float sheenAlbedoScaling( vec3 wo, SurfaceRecord surf ) {

		float alpha = max( surf.sheenRoughness, 0.07 );
		alpha = alpha * alpha;

		float maxSheenColor = max( max( surf.sheenColor.r, surf.sheenColor.g ), surf.sheenColor.b );

		float eWo = directionalAlbedoSheen( saturateCos( wo.z ), alpha );

		return 1.0 - maxSheenColor * eWo;

	}

`;

});

parcelRegister("hB5SN", function(module, exports) {

$parcel$export(module.exports, "inside_fog_volume_function", () => $ccfa748eb10216c5$export$9b383298f1837cb1);
const $ccfa748eb10216c5$export$9b383298f1837cb1 = /* glsl */ `

#ifndef FOG_CHECK_ITERATIONS
#define FOG_CHECK_ITERATIONS 30
#endif

// returns whether the given material is a fog material or not
bool isMaterialFogVolume( sampler2D materials, uint materialIndex ) {

	uint i = materialIndex * uint( MATERIAL_PIXELS );
	vec4 s14 = texelFetch1D( materials, i + 14u );
	return bool( int( s14.b ) & 4 );

}

// returns true if we're within the first fog volume we hit
bool bvhIntersectFogVolumeHit(
	vec3 rayOrigin, vec3 rayDirection,
	usampler2D materialIndexAttribute, sampler2D materials,
	inout Material material
) {

	material.fogVolume = false;

	for ( int i = 0; i < FOG_CHECK_ITERATIONS; i ++ ) {

		// find nearest hit
		uvec4 faceIndices = uvec4( 0u );
		vec3 faceNormal = vec3( 0.0, 0.0, 1.0 );
		vec3 barycoord = vec3( 0.0 );
		float side = 1.0;
		float dist = 0.0;
		bool hit = bvhIntersectFirstHit( bvh, rayOrigin, rayDirection, faceIndices, faceNormal, barycoord, side, dist );
		if ( hit ) {

			// if it's a fog volume return whether we hit the front or back face
			uint materialIndex = uTexelFetch1D( materialIndexAttribute, faceIndices.x ).r;
			if ( isMaterialFogVolume( materials, materialIndex ) ) {

				material = readMaterialInfo( materials, materialIndex );
				return side == - 1.0;

			} else {

				// move the ray forward
				rayOrigin = stepRayOrigin( rayOrigin, rayDirection, - faceNormal, dist );

			}

		} else {

			return false;

		}

	}

	return false;

}

`;

});

parcelRegister("1zk7M", function(module, exports) {

$parcel$export(module.exports, "attenuate_hit_function", () => $1248aba150c298a9$export$2cef3f20f6a7d7fc);
const $1248aba150c298a9$export$2cef3f20f6a7d7fc = /* glsl */ `

	// step through multiple surface hits and accumulate color attenuation based on transmissive surfaces
	// returns true if a solid surface was hit
	bool attenuateHit(
		RenderState state,
		Ray ray, float rayDist,
		out vec3 color
	) {

		// store the original bounce index so we can reset it after
		uint originalBounceIndex = sobolBounceIndex;

		int traversals = state.traversals;
		int transmissiveTraversals = state.transmissiveTraversals;
		bool isShadowRay = state.isShadowRay;
		Material fogMaterial = state.fogMaterial;

		vec3 startPoint = ray.origin;

		// hit results
		SurfaceHit surfaceHit;

		color = vec3( 1.0 );

		bool result = true;
		for ( int i = 0; i < traversals; i ++ ) {

			sobolBounceIndex ++;

			int hitType = traceScene( ray, fogMaterial, surfaceHit );

			if ( hitType == FOG_HIT ) {

				result = true;
				break;

			} else if ( hitType == SURFACE_HIT ) {

				float totalDist = distance( startPoint, ray.origin + ray.direction * surfaceHit.dist );
				if ( totalDist > rayDist ) {

					result = false;
					break;

				}

				// TODO: attenuate the contribution based on the PDF of the resulting ray including refraction values
				// Should be able to work using the material BSDF functions which will take into account specularity, etc.
				// TODO: should we account for emissive surfaces here?

				uint materialIndex = uTexelFetch1D( materialIndexAttribute, surfaceHit.faceIndices.x ).r;
				Material material = readMaterialInfo( materials, materialIndex );

				// adjust the ray to the new surface
				bool isEntering = surfaceHit.side == 1.0;
				ray.origin = stepRayOrigin( ray.origin, ray.direction, - surfaceHit.faceNormal, surfaceHit.dist );

				#if FEATURE_FOG

				if ( material.fogVolume ) {

					fogMaterial = material;
					fogMaterial.fogVolume = surfaceHit.side == 1.0;
					i -= sign( transmissiveTraversals );
					transmissiveTraversals --;
					continue;

				}

				#endif

				if ( ! material.castShadow && isShadowRay ) {

					continue;

				}

				vec2 uv = textureSampleBarycoord( attributesArray, ATTR_UV, surfaceHit.barycoord, surfaceHit.faceIndices.xyz ).xy;
				vec4 vertexColor = textureSampleBarycoord( attributesArray, ATTR_COLOR, surfaceHit.barycoord, surfaceHit.faceIndices.xyz );

				// albedo
				vec4 albedo = vec4( material.color, material.opacity );
				if ( material.map != - 1 ) {

					vec3 uvPrime = material.mapTransform * vec3( uv, 1 );
					albedo *= texture2D( textures, vec3( uvPrime.xy, material.map ) );

				}

				if ( material.vertexColors ) {

					albedo *= vertexColor;

				}

				// alphaMap
				if ( material.alphaMap != - 1 ) {

					vec3 uvPrime = material.alphaMapTransform * vec3( uv, 1 );
					albedo.a *= texture2D( textures, vec3( uvPrime.xy, material.alphaMap ) ).x;

				}

				// transmission
				float transmission = material.transmission;
				if ( material.transmissionMap != - 1 ) {

					vec3 uvPrime = material.transmissionMapTransform * vec3( uv, 1 );
					transmission *= texture2D( textures, vec3( uvPrime.xy, material.transmissionMap ) ).r;

				}

				// metalness
				float metalness = material.metalness;
				if ( material.metalnessMap != - 1 ) {

					vec3 uvPrime = material.metalnessMapTransform * vec3( uv, 1 );
					metalness *= texture2D( textures, vec3( uvPrime.xy, material.metalnessMap ) ).b;

				}

				float alphaTest = material.alphaTest;
				bool useAlphaTest = alphaTest != 0.0;
				float transmissionFactor = ( 1.0 - metalness ) * transmission;
				if (
					transmissionFactor < rand( 9 ) && ! (
						// material sidedness
						material.side != 0.0 && surfaceHit.side == material.side

						// alpha test
						|| useAlphaTest && albedo.a < alphaTest

						// opacity
						|| material.transparent && ! useAlphaTest && albedo.a < rand( 10 )
					)
				) {

					result = true;
					break;

				}

				if ( surfaceHit.side == 1.0 && isEntering ) {

					// only attenuate by surface color on the way in
					color *= mix( vec3( 1.0 ), albedo.rgb, transmissionFactor );

				} else if ( surfaceHit.side == - 1.0 ) {

					// attenuate by medium once we hit the opposite side of the model
					color *= transmissionAttenuation( surfaceHit.dist, material.attenuationColor, material.attenuationDistance );

				}

				bool isTransmissiveRay = dot( ray.direction, surfaceHit.faceNormal * surfaceHit.side ) < 0.0;
				if ( ( isTransmissiveRay || isEntering ) && transmissiveTraversals > 0 ) {

					i -= sign( transmissiveTraversals );
					transmissiveTraversals --;

				}

			} else {

				result = false;
				break;

			}

		}

		// reset the bounce index
		sobolBounceIndex = originalBounceIndex;
		return result;

	}

`;

});

parcelRegister("eJ3gD", function(module, exports) {

$parcel$export(module.exports, "camera_util_functions", () => $ab87cd757b5ff812$export$4f78a71f798e1125);
const $ab87cd757b5ff812$export$4f78a71f798e1125 = /* glsl */ `

	vec3 ndcToRayOrigin( vec2 coord ) {

		vec4 rayOrigin4 = cameraWorldMatrix * invProjectionMatrix * vec4( coord, - 1.0, 1.0 );
		return rayOrigin4.xyz / rayOrigin4.w;
	}

	Ray getCameraRay() {

		vec2 ssd = vec2( 1.0 ) / resolution;

		// Jitter the camera ray by finding a uv coordinate at a random sample
		// around this pixel's UV coordinate for AA
		vec2 ruv = rand2( 0 );
		vec2 jitteredUv = vUv + vec2( tentFilter( ruv.x ) * ssd.x, tentFilter( ruv.y ) * ssd.y );
		Ray ray;

		#if CAMERA_TYPE == 2

			// Equirectangular projection
			vec4 rayDirection4 = vec4( equirectUvToDirection( jitteredUv ), 0.0 );
			vec4 rayOrigin4 = vec4( 0.0, 0.0, 0.0, 1.0 );

			rayDirection4 = cameraWorldMatrix * rayDirection4;
			rayOrigin4 = cameraWorldMatrix * rayOrigin4;

			ray.direction = normalize( rayDirection4.xyz );
			ray.origin = rayOrigin4.xyz / rayOrigin4.w;

		#else

			// get [- 1, 1] normalized device coordinates
			vec2 ndc = 2.0 * jitteredUv - vec2( 1.0 );
			ray.origin = ndcToRayOrigin( ndc );

			#if CAMERA_TYPE == 1

				// Orthographic projection
				ray.direction = ( cameraWorldMatrix * vec4( 0.0, 0.0, - 1.0, 0.0 ) ).xyz;
				ray.direction = normalize( ray.direction );

			#else

				// Perspective projection
				ray.direction = normalize( mat3( cameraWorldMatrix ) * ( invProjectionMatrix * vec4( ndc, 0.0, 1.0 ) ).xyz );

			#endif

		#endif

		#if FEATURE_DOF
		{

			// depth of field
			vec3 focalPoint = ray.origin + normalize( ray.direction ) * physicalCamera.focusDistance;

			// get the aperture sample
			// if blades === 0 then we assume a circle
			vec3 shapeUVW= rand3( 1 );
			int blades = physicalCamera.apertureBlades;
			float anamorphicRatio = physicalCamera.anamorphicRatio;
			vec2 apertureSample = sampleAperture( blades, shapeUVW );
			apertureSample *= physicalCamera.bokehSize * 0.5 * 1e-3;

			// rotate the aperture shape
			apertureSample =
				rotateVector( apertureSample, physicalCamera.apertureRotation ) *
				saturate( vec2( anamorphicRatio, 1.0 / anamorphicRatio ) );

			// create the new ray
			ray.origin += ( cameraWorldMatrix * vec4( apertureSample, 0.0, 0.0 ) ).xyz;
			ray.direction = focalPoint - ray.origin;

		}
		#endif

		ray.direction = normalize( ray.direction );

		return ray;

	}

`;

});

parcelRegister("eZnIg", function(module, exports) {

$parcel$export(module.exports, "direct_light_contribution_function", () => $ae99281879ede2b8$export$dfc473f79b3116e1);
const $ae99281879ede2b8$export$dfc473f79b3116e1 = /*glsl*/ `

	vec3 directLightContribution( vec3 worldWo, SurfaceRecord surf, RenderState state, vec3 rayOrigin ) {

		vec3 result = vec3( 0.0 );

		// uniformly pick a light or environment map
		if( lightsDenom != 0.0 && rand( 5 ) < float( lights.count ) / lightsDenom ) {

			// sample a light or environment
			LightRecord lightRec = randomLightSample( lights.tex, iesProfiles, lights.count, rayOrigin, rand3( 6 ) );

			bool isSampleBelowSurface = ! surf.volumeParticle && dot( surf.faceNormal, lightRec.direction ) < 0.0;
			if ( isSampleBelowSurface ) {

				lightRec.pdf = 0.0;

			}

			// check if a ray could even reach the light area
			Ray lightRay;
			lightRay.origin = rayOrigin;
			lightRay.direction = lightRec.direction;
			vec3 attenuatedColor;
			if (
				lightRec.pdf > 0.0 &&
				isDirectionValid( lightRec.direction, surf.normal, surf.faceNormal ) &&
				! attenuateHit( state, lightRay, lightRec.dist, attenuatedColor )
			) {

				// get the material pdf
				vec3 sampleColor;
				float lightMaterialPdf = bsdfResult( worldWo, lightRec.direction, surf, sampleColor );
				bool isValidSampleColor = all( greaterThanEqual( sampleColor, vec3( 0.0 ) ) );
				if ( lightMaterialPdf > 0.0 && isValidSampleColor ) {

					// weight the direct light contribution
					float lightPdf = lightRec.pdf / lightsDenom;
					float misWeight = lightRec.type == SPOT_LIGHT_TYPE || lightRec.type == DIR_LIGHT_TYPE || lightRec.type == POINT_LIGHT_TYPE ? 1.0 : misHeuristic( lightPdf, lightMaterialPdf );
					result = attenuatedColor * lightRec.emission * state.throughputColor * sampleColor * misWeight / lightPdf;

				}

			}

		} else if ( envMapInfo.totalSum != 0.0 && environmentIntensity != 0.0 ) {

			// find a sample in the environment map to include in the contribution
			vec3 envColor, envDirection;
			float envPdf = sampleEquirectProbability( rand2( 7 ), envColor, envDirection );
			envDirection = invEnvRotation3x3 * envDirection;

			// this env sampling is not set up for transmissive sampling and yields overly bright
			// results so we ignore the sample in this case.
			// TODO: this should be improved but how? The env samples could traverse a few layers?
			bool isSampleBelowSurface = ! surf.volumeParticle && dot( surf.faceNormal, envDirection ) < 0.0;
			if ( isSampleBelowSurface ) {

				envPdf = 0.0;

			}

			// check if a ray could even reach the surface
			Ray envRay;
			envRay.origin = rayOrigin;
			envRay.direction = envDirection;
			vec3 attenuatedColor;
			if (
				envPdf > 0.0 &&
				isDirectionValid( envDirection, surf.normal, surf.faceNormal ) &&
				! attenuateHit( state, envRay, INFINITY, attenuatedColor )
			) {

				// get the material pdf
				vec3 sampleColor;
				float envMaterialPdf = bsdfResult( worldWo, envDirection, surf, sampleColor );
				bool isValidSampleColor = all( greaterThanEqual( sampleColor, vec3( 0.0 ) ) );
				if ( envMaterialPdf > 0.0 && isValidSampleColor ) {

					// weight the direct light contribution
					envPdf /= lightsDenom;
					float misWeight = misHeuristic( envPdf, envMaterialPdf );
					result = attenuatedColor * environmentIntensity * envColor * state.throughputColor * sampleColor * misWeight / envPdf;

				}

			}

		}

		// Function changed to have a single return statement to potentially help with crashes on Mac OS.
		// See issue #470
		return result;

	}

`;

});

parcelRegister("bwtQK", function(module, exports) {

$parcel$export(module.exports, "get_surface_record_function", () => $8639d66b89a7dedc$export$4b59180d6e57d4f);
const $8639d66b89a7dedc$export$4b59180d6e57d4f = /* glsl */ `

	#define SKIP_SURFACE 0
	#define HIT_SURFACE 1
	int getSurfaceRecord(
		Material material, SurfaceHit surfaceHit, sampler2DArray attributesArray,
		float accumulatedRoughness,
		inout SurfaceRecord surf
	) {

		if ( material.fogVolume ) {

			vec3 normal = vec3( 0, 0, 1 );

			SurfaceRecord fogSurface;
			fogSurface.volumeParticle = true;
			fogSurface.color = material.color;
			fogSurface.emission = material.emissiveIntensity * material.emissive;
			fogSurface.normal = normal;
			fogSurface.faceNormal = normal;
			fogSurface.clearcoatNormal = normal;

			surf = fogSurface;
			return HIT_SURFACE;

		}

		// uv coord for textures
		vec2 uv = textureSampleBarycoord( attributesArray, ATTR_UV, surfaceHit.barycoord, surfaceHit.faceIndices.xyz ).xy;
		vec4 vertexColor = textureSampleBarycoord( attributesArray, ATTR_COLOR, surfaceHit.barycoord, surfaceHit.faceIndices.xyz );

		// albedo
		vec4 albedo = vec4( material.color, material.opacity );
		if ( material.map != - 1 ) {

			vec3 uvPrime = material.mapTransform * vec3( uv, 1 );
			albedo *= texture2D( textures, vec3( uvPrime.xy, material.map ) );

		}

		if ( material.vertexColors ) {

			albedo *= vertexColor;

		}

		// alphaMap
		if ( material.alphaMap != - 1 ) {

			vec3 uvPrime = material.alphaMapTransform * vec3( uv, 1 );
			albedo.a *= texture2D( textures, vec3( uvPrime.xy, material.alphaMap ) ).x;

		}

		// possibly skip this sample if it's transparent, alpha test is enabled, or we hit the wrong material side
		// and it's single sided.
		// - alpha test is disabled when it === 0
		// - the material sidedness test is complicated because we want light to pass through the back side but still
		// be able to see the front side. This boolean checks if the side we hit is the front side on the first ray
		// and we're rendering the other then we skip it. Do the opposite on subsequent bounces to get incoming light.
		float alphaTest = material.alphaTest;
		bool useAlphaTest = alphaTest != 0.0;
		if (
			// material sidedness
			material.side != 0.0 && surfaceHit.side != material.side

			// alpha test
			|| useAlphaTest && albedo.a < alphaTest

			// opacity
			|| material.transparent && ! useAlphaTest && albedo.a < rand( 3 )
		) {

			return SKIP_SURFACE;

		}

		// fetch the interpolated smooth normal
		vec3 normal = normalize( textureSampleBarycoord(
			attributesArray,
			ATTR_NORMAL,
			surfaceHit.barycoord,
			surfaceHit.faceIndices.xyz
		).xyz );

		// roughness
		float roughness = material.roughness;
		if ( material.roughnessMap != - 1 ) {

			vec3 uvPrime = material.roughnessMapTransform * vec3( uv, 1 );
			roughness *= texture2D( textures, vec3( uvPrime.xy, material.roughnessMap ) ).g;

		}

		// metalness
		float metalness = material.metalness;
		if ( material.metalnessMap != - 1 ) {

			vec3 uvPrime = material.metalnessMapTransform * vec3( uv, 1 );
			metalness *= texture2D( textures, vec3( uvPrime.xy, material.metalnessMap ) ).b;

		}

		// emission
		vec3 emission = material.emissiveIntensity * material.emissive;
		if ( material.emissiveMap != - 1 ) {

			vec3 uvPrime = material.emissiveMapTransform * vec3( uv, 1 );
			emission *= texture2D( textures, vec3( uvPrime.xy, material.emissiveMap ) ).xyz;

		}

		// transmission
		float transmission = material.transmission;
		if ( material.transmissionMap != - 1 ) {

			vec3 uvPrime = material.transmissionMapTransform * vec3( uv, 1 );
			transmission *= texture2D( textures, vec3( uvPrime.xy, material.transmissionMap ) ).r;

		}

		// normal
		if ( material.flatShading ) {

			// if we're rendering a flat shaded object then use the face normals - the face normal
			// is provided based on the side the ray hits the mesh so flip it to align with the
			// interpolated vertex normals.
			normal = surfaceHit.faceNormal * surfaceHit.side;

		}

		vec3 baseNormal = normal;
		if ( material.normalMap != - 1 ) {

			vec4 tangentSample = textureSampleBarycoord(
				attributesArray,
				ATTR_TANGENT,
				surfaceHit.barycoord,
				surfaceHit.faceIndices.xyz
			);

			// some provided tangents can be malformed (0, 0, 0) causing the normal to be degenerate
			// resulting in NaNs and slow path tracing.
			if ( length( tangentSample.xyz ) > 0.0 ) {

				vec3 tangent = normalize( tangentSample.xyz );
				vec3 bitangent = normalize( cross( normal, tangent ) * tangentSample.w );
				mat3 vTBN = mat3( tangent, bitangent, normal );

				vec3 uvPrime = material.normalMapTransform * vec3( uv, 1 );
				vec3 texNormal = texture2D( textures, vec3( uvPrime.xy, material.normalMap ) ).xyz * 2.0 - 1.0;
				texNormal.xy *= material.normalScale;
				normal = vTBN * texNormal;

			}

		}

		normal *= surfaceHit.side;

		// clearcoat
		float clearcoat = material.clearcoat;
		if ( material.clearcoatMap != - 1 ) {

			vec3 uvPrime = material.clearcoatMapTransform * vec3( uv, 1 );
			clearcoat *= texture2D( textures, vec3( uvPrime.xy, material.clearcoatMap ) ).r;

		}

		// clearcoatRoughness
		float clearcoatRoughness = material.clearcoatRoughness;
		if ( material.clearcoatRoughnessMap != - 1 ) {

			vec3 uvPrime = material.clearcoatRoughnessMapTransform * vec3( uv, 1 );
			clearcoatRoughness *= texture2D( textures, vec3( uvPrime.xy, material.clearcoatRoughnessMap ) ).g;

		}

		// clearcoatNormal
		vec3 clearcoatNormal = baseNormal;
		if ( material.clearcoatNormalMap != - 1 ) {

			vec4 tangentSample = textureSampleBarycoord(
				attributesArray,
				ATTR_TANGENT,
				surfaceHit.barycoord,
				surfaceHit.faceIndices.xyz
			);

			// some provided tangents can be malformed (0, 0, 0) causing the normal to be degenerate
			// resulting in NaNs and slow path tracing.
			if ( length( tangentSample.xyz ) > 0.0 ) {

				vec3 tangent = normalize( tangentSample.xyz );
				vec3 bitangent = normalize( cross( clearcoatNormal, tangent ) * tangentSample.w );
				mat3 vTBN = mat3( tangent, bitangent, clearcoatNormal );

				vec3 uvPrime = material.clearcoatNormalMapTransform * vec3( uv, 1 );
				vec3 texNormal = texture2D( textures, vec3( uvPrime.xy, material.clearcoatNormalMap ) ).xyz * 2.0 - 1.0;
				texNormal.xy *= material.clearcoatNormalScale;
				clearcoatNormal = vTBN * texNormal;

			}

		}

		clearcoatNormal *= surfaceHit.side;

		// sheenColor
		vec3 sheenColor = material.sheenColor;
		if ( material.sheenColorMap != - 1 ) {

			vec3 uvPrime = material.sheenColorMapTransform * vec3( uv, 1 );
			sheenColor *= texture2D( textures, vec3( uvPrime.xy, material.sheenColorMap ) ).rgb;

		}

		// sheenRoughness
		float sheenRoughness = material.sheenRoughness;
		if ( material.sheenRoughnessMap != - 1 ) {

			vec3 uvPrime = material.sheenRoughnessMapTransform * vec3( uv, 1 );
			sheenRoughness *= texture2D( textures, vec3( uvPrime.xy, material.sheenRoughnessMap ) ).a;

		}

		// iridescence
		float iridescence = material.iridescence;
		if ( material.iridescenceMap != - 1 ) {

			vec3 uvPrime = material.iridescenceMapTransform * vec3( uv, 1 );
			iridescence *= texture2D( textures, vec3( uvPrime.xy, material.iridescenceMap ) ).r;

		}

		// iridescence thickness
		float iridescenceThickness = material.iridescenceThicknessMaximum;
		if ( material.iridescenceThicknessMap != - 1 ) {

			vec3 uvPrime = material.iridescenceThicknessMapTransform * vec3( uv, 1 );
			float iridescenceThicknessSampled = texture2D( textures, vec3( uvPrime.xy, material.iridescenceThicknessMap ) ).g;
			iridescenceThickness = mix( material.iridescenceThicknessMinimum, material.iridescenceThicknessMaximum, iridescenceThicknessSampled );

		}

		iridescence = iridescenceThickness == 0.0 ? 0.0 : iridescence;

		// specular color
		vec3 specularColor = material.specularColor;
		if ( material.specularColorMap != - 1 ) {

			vec3 uvPrime = material.specularColorMapTransform * vec3( uv, 1 );
			specularColor *= texture2D( textures, vec3( uvPrime.xy, material.specularColorMap ) ).rgb;

		}

		// specular intensity
		float specularIntensity = material.specularIntensity;
		if ( material.specularIntensityMap != - 1 ) {

			vec3 uvPrime = material.specularIntensityMapTransform * vec3( uv, 1 );
			specularIntensity *= texture2D( textures, vec3( uvPrime.xy, material.specularIntensityMap ) ).a;

		}

		surf.volumeParticle = false;

		surf.faceNormal = surfaceHit.faceNormal;
		surf.normal = normal;

		surf.metalness = metalness;
		surf.color = albedo.rgb;
		surf.emission = emission;

		surf.ior = material.ior;
		surf.transmission = transmission;
		surf.thinFilm = material.thinFilm;
		surf.attenuationColor = material.attenuationColor;
		surf.attenuationDistance = material.attenuationDistance;

		surf.clearcoatNormal = clearcoatNormal;
		surf.clearcoat = clearcoat;

		surf.sheen = material.sheen;
		surf.sheenColor = sheenColor;

		surf.iridescence = iridescence;
		surf.iridescenceIor = material.iridescenceIor;
		surf.iridescenceThickness = iridescenceThickness;

		surf.specularColor = specularColor;
		surf.specularIntensity = specularIntensity;

		// apply perceptual roughness factor from gltf. sheen perceptual roughness is
		// applied by its brdf function
		// https://registry.khronos.org/glTF/specs/2.0/glTF-2.0.html#microfacet-surfaces
		surf.roughness = roughness * roughness;
		surf.clearcoatRoughness = clearcoatRoughness * clearcoatRoughness;
		surf.sheenRoughness = sheenRoughness;

		// frontFace is used to determine transmissive properties and PDF. If no transmission is used
		// then we can just always assume this is a front face.
		surf.frontFace = surfaceHit.side == 1.0 || transmission == 0.0;
		surf.eta = material.thinFilm || surf.frontFace ? 1.0 / material.ior : material.ior;
		surf.f0 = iorRatioToF0( surf.eta );

		// Compute the filtered roughness value to use during specular reflection computations.
		// The accumulated roughness value is scaled by a user setting and a "magic value" of 5.0.
		// If we're exiting something transmissive then scale the factor down significantly so we can retain
		// sharp internal reflections
		surf.filteredRoughness = applyFilteredGlossy( surf.roughness, accumulatedRoughness );
		surf.filteredClearcoatRoughness = applyFilteredGlossy( surf.clearcoatRoughness, accumulatedRoughness );

		// get the normal frames
		surf.normalBasis = getBasisFromNormal( surf.normal );
		surf.normalInvBasis = inverse( surf.normalBasis );

		surf.clearcoatBasis = getBasisFromNormal( surf.clearcoatNormal );
		surf.clearcoatInvBasis = inverse( surf.clearcoatBasis );

		return HIT_SURFACE;

	}
`;

});

parcelRegister("ioRiK", function(module, exports) {

$parcel$export(module.exports, "render_structs", () => $d653d06e472927b5$export$dd7d5457c7c15273);
const $d653d06e472927b5$export$dd7d5457c7c15273 = /* glsl */ `

	struct Ray {

		vec3 origin;
		vec3 direction;

	};

	struct SurfaceHit {

		uvec4 faceIndices;
		vec3 barycoord;
		vec3 faceNormal;
		float side;
		float dist;

	};

	struct RenderState {

		bool firstRay;
		bool transmissiveRay;
		bool isShadowRay;
		float accumulatedRoughness;
		int transmissiveTraversals;
		int traversals;
		uint depth;
		vec3 throughputColor;
		Material fogMaterial;

	};

	RenderState initRenderState() {

		RenderState result;
		result.firstRay = true;
		result.transmissiveRay = true;
		result.isShadowRay = false;
		result.accumulatedRoughness = 0.0;
		result.transmissiveTraversals = 0;
		result.traversals = 0;
		result.throughputColor = vec3( 1.0 );
		result.depth = 0u;
		result.fogMaterial.fogVolume = false;
		return result;

	}

`;

});

parcelRegister("euI5d", function(module, exports) {

$parcel$export(module.exports, "trace_scene_function", () => $a8d61006286aaacf$export$32c6608be890cd25);
const $a8d61006286aaacf$export$32c6608be890cd25 = /* glsl */ `

	#define NO_HIT 0
	#define SURFACE_HIT 1
	#define LIGHT_HIT 2
	#define FOG_HIT 3

	// Passing the global variable 'lights' into this function caused shader program errors.
	// So global variables like 'lights' and 'bvh' were moved out of the function parameters.
	// For more information, refer to: https://github.com/gkjohnson/three-gpu-pathtracer/pull/457
	int traceScene(
		Ray ray, Material fogMaterial, inout SurfaceHit surfaceHit
	) {

		int result = NO_HIT;
		bool hit = bvhIntersectFirstHit( bvh, ray.origin, ray.direction, surfaceHit.faceIndices, surfaceHit.faceNormal, surfaceHit.barycoord, surfaceHit.side, surfaceHit.dist );

		#if FEATURE_FOG

		if ( fogMaterial.fogVolume ) {

			// offset the distance so we don't run into issues with particles on the same surface
			// as other objects
			float particleDist = intersectFogVolume( fogMaterial, rand( 1 ) );
			if ( particleDist + RAY_OFFSET < surfaceHit.dist ) {

				surfaceHit.side = 1.0;
				surfaceHit.faceNormal = normalize( - ray.direction );
				surfaceHit.dist = particleDist;
				return FOG_HIT;

			}

		}

		#endif

		if ( hit ) {

			result = SURFACE_HIT;

		}

		return result;

	}

`;

});




//# sourceMappingURL=areaLight.2aa801de.js.map
